import React, { useCallback, useEffect, useState, useMemo } from "react";
import {
  Table,
  Button,
  Modal,
  Input,
  Form,
  Typography,
  message,
  Select,
  Tabs,
  Upload,
  List,
  Card,
} from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined, FileOutlined, FilePdfOutlined, FileImageOutlined, DownloadOutlined } from "@ant-design/icons";
import Header from "./Components/Header";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { UploadOutlined } from "@ant-design/icons";
import { addPatientDocuments, getPatientBloodWork, downloadBloodWork } from "../../redux/doctorSlice";
import { baseUrl } from "../../../utils/envAccess";
import {
  getPatientMed,
  addPatientMed,
  addPatientSupplement,
  getPatientSupplements,
  deletePatientMed,
  editPatientMed,
  editPatientSupplement,
  deletePatientSupplement,
} from "../../redux/doctorSlice";
import moment from "moment";
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import "./medication.css";
import { getUserProfile } from "../../redux/AuthController";
import fertilityLogo from '../../../assets/images/auth/fertilityImage.svg';
import { ROUTE_STRENGTH_MAP, ALL_ROUTES, DEFAULT_STRENGTHS } from "../../../utils/medicationData";
import { getMedicationSuggestions, getMedicationRoutes, getMedicationRoutesDebounced, getMedicationStrengths } from "../../../utils/rxnormApi";
import PharmacyConfirmationModal from "./PharmacyConfirmationModal";
const { Text, Link } = Typography;
const { Dragger } = Upload;

const MedicationTable = () => {
  const patient = JSON.parse(localStorage.getItem("patient")) || {
    userRef: "",
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const breakpoints = {
  //   xs: 480,
  //   sm: 576,
  //   md: 768,
  //   lg: 992,
  //   xl: 1200,
  // };


  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isUploadModalVisible, setIsUploadModalVisible] = useState(false);
  const [newLabResultFile, setNewLabResultFile] = useState(null);
  const [newLabResultName, setNewLabResultName] = useState("");
  const [prescriptionFiles, setPrescriptionFiles] = useState([]);

  //const [isNewLabResultVisible, setIsNewLabResultVisible] = useState(false);
  //const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isAddSupplementModalVisible, setIsAddSupplementModalVisible] =
    useState(false);
  const [supplements, setSupplements] = useState([]);
  const [activeTab, setActiveTab] = useState("medications");
  const [localMedications, setLocalMedications] = useState([]);
  const [serverMedications, setServerMedications] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingMedication, setEditingMedication] = useState(null);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [selectedMedication, setSelectedMedication] = useState(null);
  const [selectedStrength, setSelectedStrength] = useState(null);
  const [customStrengthAmount, setCustomStrengthAmount] = useState("");
  const [customStrengthUnit, setCustomStrengthUnit] = useState("");
  const [previewVisible, setPreviewVisible] = useState(false);

  const [showCustomMedicationInput, setShowCustomMedicationInput] = useState(false);
  const [customMedicationName, setCustomMedicationName] = useState("");

  const [customRoute, setCustomRoute] = useState("");
  const [otherRoute, setOtherRoute] = useState(false);
  const [customDose, setCustomDose] = useState("");
  const [otherDose, setOtherDose] = useState(false);
  const [customFrequency, setCustomFrequency] = useState("");
  const [otherFrequency, setOtherFrequency] = useState(false);
  const [customDuration, setCustomDuration] = useState("");
  const [otherDuration, setOtherDuration] = useState(false);
  const [customStrengthUnitText, setCustomStrengthUnitText] = useState("");
  const [otherStrengthUnit, setOtherStrengthUnit] = useState(false);
  const [customSupplementRoute, setCustomSupplementRoute] = useState("");
  const [otherSupplementRoute, setOtherSupplementRoute] = useState(false);
  const [customSupplementFrequency, setCustomSupplementFrequency] = useState("");
  const [otherSupplementFrequency, setOtherSupplementFrequency] = useState(false);
  const [customSupplementMetric, setCustomSupplementMetric] = useState("");
  const [otherSupplementMetric, setOtherSupplementMetric] = useState(false);
  const [customSupplementAmountExtra, setCustomSupplementAmountExtra] = useState("");
  const [otherSupplementAmountExtra, setOtherSupplementAmountExtra] = useState(false);
  
  const [isEditSupplementModalVisible, setIsEditSupplementModalVisible] = useState(false);
  const [editingSupplement, setEditingSupplement] = useState(null);
  const [customEditSupplementRoute, setCustomEditSupplementRoute] = useState("");
  const [otherEditSupplementRoute, setOtherEditSupplementRoute] = useState(false);
  const [customEditSupplementFrequency, setCustomEditSupplementFrequency] = useState("");
  const [otherEditSupplementFrequency, setOtherEditSupplementFrequency] = useState(false);
  const [customEditSupplementMetric, setCustomEditSupplementMetric] = useState("");
  const [otherEditSupplementMetric, setOtherEditSupplementMetric] = useState(false);
  const [customEditSupplementAmountExtra, setCustomEditSupplementAmountExtra] = useState("");
  const [otherEditSupplementAmountExtra, setOtherEditSupplementAmountExtra] = useState(false);
  // RxNorm API states
  const [rxnormSuggestions, setRxnormSuggestions] = useState([]);
  const [isSearchingRxnorm, setIsSearchingRxnorm] = useState(false);
  const [selectedRxnormMedication, setSelectedRxnormMedication] = useState(null);
  const [rxnormRoutes, setRxnormRoutes] = useState([]);
  const [rxnormStrengths, setRxnormStrengths] = useState([]);
  const [isAddFormValid, setIsAddFormValid] = useState(false);
  // Add local state for user profile
  const [userProfileData, setUserProfileData] = useState({
    firstName: '',
    lastName: '',
    designation: '',
    licenceNumber: '',
    phoneNumber: ''
  });

  const [form] = Form.useForm();
  const [supplementForm] = Form.useForm();
  const [editSupplementForm] = Form.useForm();
  const [editForm] = Form.useForm();
  
  const med = useSelector((state) => state.doctor.medications);
  const supplementsList = useSelector((state) => state.doctor.supplements);
  const authState = useSelector((state) => state?.authentication?.userAuth);

  // Update server medications when Redux data changes
  useEffect(() => {
    if (med) {
      setServerMedications(med);
    }
  }, [med]);

  const getFileIcon = (filename) => {
    console.log(filename, "lll");

    if (!filename)
      return <FileOutlined style={{ color: "#1890ff", fontSize: 24 }} />;
    const extension = filename.split(".").pop().toLowerCase();
    switch (extension) {
      case "pdf":
        return <FilePdfOutlined style={{ color: "red", fontSize: 24 }} />;
      case "png":
      case "jpg":
      case "jpeg":
        return <FileImageOutlined style={{ color: "#52c41a", fontSize: 24 }} />;
      default:
        return <FileOutlined style={{ color: "#1890ff", fontSize: 24 }} />;
    }
  };
  const openModal = (modalType) => {
    setIsModalVisible(modalType === "patientSelect");
    //setIsNewLabResultVisible(modalType === "newLabResult");
  };
  
  const userProfile = useSelector((state) => state?.profile?.userData);
  console.log('User profile:', userProfile);

  const handleDownload = async (fileRef, filename) => {
    try {
      const resultAction = await dispatch(downloadBloodWork(fileRef));
      if (downloadBloodWork.fulfilled.match(resultAction)) {
        const mimeType = getFileType(filename);
        const blob = new Blob([resultAction.payload], { type: mimeType });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename || `${fileRef}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } else {
        message.error("Failed to download file.");
      }
    } catch (error) {
      message.error("Download error.");
    }
  };
  useEffect(() => {
    if (!patient.userRef) {
      setIsModalVisible(true);
    } else {
      dispatch(getPatientMed(patient.userRef));
      dispatch(getPatientSupplements(patient.userRef));
    }
  }, [dispatch, patient.userRef]);



  useEffect(() => {
    if (supplementsList) {
      setSupplements(supplementsList);
    }
  }, [supplementsList]);

  // Load medications from localStorage on mount
  useEffect(() => {
    const stored = localStorage.getItem('localMedications');
    if (stored) {
      setLocalMedications(JSON.parse(stored));
    }
  }, []);

  // Save medications to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem('localMedications', JSON.stringify(localMedications));
  }, [localMedications]);

  // Function to fetch user profile data
  const fetchUserProfile = useCallback(async () => {
    try {
      const resultAction = await dispatch(getUserProfile());
      const response = resultAction.payload;
      console.log('Profile API Response:', response);
      
      // Check if response is nested in an obj property
      const userData = response?.obj || response;
      
      if (userData) {
        console.log('User data:', userData);
        // Extract signature URL from the nested response structure
        const signatureUrl = userData?.signature?.response?.secure_url || 
                           userData?.signature?.file?.response?.secure_url || '';
        
        setUserProfileData({
          firstName: userData?.firstname || userData?.firstName || '',
          lastName: userData?.lastName || userData?.lastname || '',
          designation: userData?.designation || '',
          licenceNumber: userData?.licenseNumber || userData?.licenceNumber || '', // Fixed spelling
          phoneNumber: userData?.phoneNumber || '',
          signature: userData?.signature || ''
        });
        console.log('User profile data set:', userData);
        console.log('Signature URL extracted:', signatureUrl);
      }
    } catch (error) {
      console.error('Profile fetch error:', error);
    }
  }, [dispatch]);

  // Fetch user profile data when component mounts
  useEffect(() => {
    if (!userProfile || Object.keys(userProfile).length === 0) {
      dispatch(getUserProfile());
    }
  }, [dispatch, userProfile]);

  // Fetch user profile data on component mount
  useEffect(() => {
    fetchUserProfile();
  }, [fetchUserProfile]);

  // Shared validator for the Add modal submit button.
  // When "Other (specify)" is active for a field, the form field is set to ''
  // so we check the custom state variable instead.
  const checkAddFormValid = () => {
    try {
      const all = form.getFieldsValue();
      const effectiveValues = {
        drugName: all.drugName,
        route: otherRoute ? customRoute : all.route,
        strength: all.strength,
        dose: otherDose ? customDose : all.dose,
        frequency: otherFrequency ? customFrequency : all.frequency,
        duration: otherDuration ? customDuration : all.duration,
      };
      const hasAllRequired = Object.values(effectiveValues).every(
        v => v !== undefined && v !== null && String(v).trim() !== ''
      );
      setIsAddFormValid(hasAllRequired);
    } catch (e) {
      setIsAddFormValid(false);
    }
  };

  const handleModalClose = () => {
    navigate("/doctor");
  };

  const showAddModal = () => {
    // Clear form and reset states for new medication
    form.resetFields();
    setSelectedMedication('');
    setSelectedRxnormMedication(null);
    setRxnormRoutes([]);
    setRxnormStrengths([]);
    setSelectedStrength('');
    setCustomStrengthAmount('');
    setCustomStrengthUnit('');
    setRxnormSuggestions([]);
    setIsAddFormValid(false);
    setIsAddModalVisible(true);
  };

  const showAddSupplementModal = () => {
    setIsAddSupplementModalVisible(true);
  };
  const showAddPrecriptionModal = () => {
    // setIsAddPrecriptionModalVisible(true);
  };

  const fetchPatientBloodWork = useCallback(
    async () => {
      if (!patient.userRef) {
        console.log("Opening patient select modal");
        openModal("patientSelect");
        return;
      }

     // console.log("Fetching prescription files (fileType 3)...");
      const resultAction = await dispatch(
        getPatientBloodWork({ patientId: patient.userRef, fileType: 3 })
      );

      if (getPatientBloodWork.fulfilled.match(resultAction)) {
        setPrescriptionFiles(resultAction.payload);
      } else {
        message.error("Failed to fetch prescription files.");
      }
    },
    [patient.userRef, dispatch]
  );
  useEffect(() => {
    fetchPatientBloodWork();
  }, [dispatch, patient.userRef, fetchPatientBloodWork]);

  const handleAdd = () => {
    form.validateFields().then(async (values) => {
      try {
        if (editingIndex !== null) {
          // Update existing medication
          setLocalMedications((prev) => prev.map((med, idx) => idx === editingIndex ? {
            drugName: values.drugName,
            strength: values.strength,
            route: values.route,
            dose: values.dose,
            frequency: values.frequency,
            duration: values.duration,
            quantity: values.quantity,
            refills: values.refills,
          } : med));
          setEditingIndex(null);
          message.success("Medication updated locally!");
        } else {
          // Add new medication to server
          const payload = {
            drugName: values.drugName,
            dose: otherDose ? customDose : values.dose,
            amount: values.quantity.toString(),
            route: otherRoute ? customRoute : values.route,
            frequency: otherFrequency ? customFrequency : values.frequency,
            strength: values.strength,
            duration: otherDuration ? customDuration : values.duration,
            refills: values.refills,
            Note: values.notes || '',
            patientRef: patient.userRef
          };

          const result = await dispatch(addPatientMed(payload));
          
          if (addPatientMed.fulfilled.match(result)) {
            message.success("Medication added successfully!");
            dispatch(getPatientMed(patient.userRef));
            setIsAddModalVisible(false);
            form.resetFields();
          } else if (addPatientMed.rejected.match(result)) {
           // console.error('Medication add rejected:', result.error);
            message.error("Failed to add medication. Please try again.");
          } else {
            message.error("Failed to add medication.");
          }
        }
      } catch (error) {
       // console.error('Error details:', error);
        message.error("Failed to add medication. Please try again.");
      }
    });
  };


  // Edit handler
  const handleEditLocal = (record, index) => {
    setEditingIndex(index);
    setIsAddModalVisible(true);
    setTimeout(() => {
      form.setFieldsValue(record);
    }, 0);
  };
  const getFileType = (filename) => {
    if (!filename) return "application/pdf"; // default to PDF
    const extension = filename.split(".").pop().toLowerCase();
    switch (extension) {
      case "pdf":
        return "application/pdf";
      case "png":
        return "image/png";
      case "jpg":
      case "jpeg":
        return "image/jpeg";
      default:
        return "application/pdf";
    }
  };
  const handleAddSupplement = () => {
    console.log('Starting supplement add process...');
    supplementForm.validateFields().then(async (values) => {
      console.log('Form values:', values);
      try {
        // Check if all required fields are filled
        const requiredFields = [
          'SupplementName',
          'Dose',
          'Metric',
          'Amount',
          'AmountExtra',
          'Route',
          'Frequency',
          'Notes'
        ];

        const missingFields = requiredFields.filter(field => {
          if (field === 'Route' && otherSupplementRoute) return !customSupplementRoute;
          if (field === 'Frequency' && otherSupplementFrequency) return !customSupplementFrequency;
          if (field === 'Metric' && otherSupplementMetric) return !customSupplementMetric;
          if (field === 'AmountExtra' && otherSupplementAmountExtra) return !customSupplementAmountExtra;
          return !values[field];
        });

        if (missingFields.length > 0) {
          message.error(`Please fill in all required fields: ${missingFields.join(', ')}`);
          return;
        }

        // Convert PascalCase to camelCase for API
        const payload = {
          supplementName: values.SupplementName,
          dose: values.Dose,
          metric: otherSupplementMetric ? customSupplementMetric : values.Metric,
          amount: String(values.Amount),
          amountExtra: otherSupplementAmountExtra ? customSupplementAmountExtra : values.AmountExtra,
          route: otherSupplementRoute ? customSupplementRoute : values.Route,
          frequency: otherSupplementFrequency ? customSupplementFrequency : values.Frequency,
          notes: values.Notes,
          patientRef: patient.userRef
        };
        console.log('Payload being sent:', payload);

        const result = await dispatch(addPatientSupplement(payload));

        if (addPatientSupplement.fulfilled.match(result)) {
          message.success("Supplement added successfully!");
          dispatch(getPatientSupplements(patient.userRef));
          setIsAddSupplementModalVisible(false);
          supplementForm.resetFields();
          setOtherSupplementRoute(false);
          setCustomSupplementRoute("");
          setOtherSupplementFrequency(false);
          setCustomSupplementFrequency("");
          setOtherSupplementMetric(false);
          setCustomSupplementMetric("");
          setOtherSupplementAmountExtra(false);
          setCustomSupplementAmountExtra("");
        } else if (addPatientSupplement.rejected.match(result)) {
          console.error('Supplement add rejected:', result.error);
          message.error("Failed to add supplement. Please try again.");
        } else {
          message.error("Failed to add supplement.");
        }
      } catch (error) {
        console.error('Error details:', error);
        message.error("Failed to add supplement. Please try again.");
      }
    }).catch((error) => {
      console.error('Form validation error:', error);
      message.error("Please check all required fields.");
    });
  };

  const SUPPLEMENT_FIXED_METRICS = ['mg', 'g', 'ml'];
  const SUPPLEMENT_FIXED_AMOUNT_EXTRAS = ['tablets', 'capsules', 'drops'];
  const SUPPLEMENT_FIXED_ROUTES = ['oral', 'topical', 'injection'];
  const SUPPLEMENT_FIXED_FREQUENCIES = ['daily', 'twice_daily', 'weekly', 'monthly'];

  const handleEditSupplement = (record) => {
    setEditingSupplement(record);

    const metricIsCustom = record.metric && !SUPPLEMENT_FIXED_METRICS.includes(record.metric);
    const amountExtraIsCustom = record.amountExtra && !SUPPLEMENT_FIXED_AMOUNT_EXTRAS.includes(record.amountExtra);
    const routeIsCustom = record.route && !SUPPLEMENT_FIXED_ROUTES.includes(record.route);
    const frequencyIsCustom = record.frequency && !SUPPLEMENT_FIXED_FREQUENCIES.includes(record.frequency);

    setOtherEditSupplementMetric(metricIsCustom);
    setCustomEditSupplementMetric(metricIsCustom ? record.metric : "");
    setOtherEditSupplementAmountExtra(amountExtraIsCustom);
    setCustomEditSupplementAmountExtra(amountExtraIsCustom ? record.amountExtra : "");
    setOtherEditSupplementRoute(routeIsCustom);
    setCustomEditSupplementRoute(routeIsCustom ? record.route : "");
    setOtherEditSupplementFrequency(frequencyIsCustom);
    setCustomEditSupplementFrequency(frequencyIsCustom ? record.frequency : "");

    
    const mappedRecord = {
      SupplementName: record.supplementName,
      Dose: record.dose,
      Metric: record.metric,
      Amount: record.amount,
      AmountExtra: record.amountExtra,
      Route: record.route,
      Frequency: record.frequency,
      Notes: record.notes,
    };

    setIsEditSupplementModalVisible(true);
    setTimeout(() => {
      editSupplementForm.setFieldsValue(mappedRecord);
    }, 100);
  };

  const closeEditSupplementModal = () => {
    setIsEditSupplementModalVisible(false);
    setEditingSupplement(null);
    editSupplementForm.resetFields();
    setOtherEditSupplementRoute(false);
    setCustomEditSupplementRoute("");
    setOtherEditSupplementFrequency(false);
    setCustomEditSupplementFrequency("");
    setOtherEditSupplementMetric(false);
    setCustomEditSupplementMetric("");
    setOtherEditSupplementAmountExtra(false);
    setCustomEditSupplementAmountExtra("");
  };

  const handleEditSupplementSubmit = () => {
    editSupplementForm.validateFields().then(async (values) => {
      const requiredFields = [
        'SupplementName',
        'Dose',
        'Metric',
        'Amount',
        'AmountExtra',
        'Route',
        'Frequency',
        'Notes'
      ];

      const missingFields = requiredFields.filter(field => {
        if (field === 'Route' && otherEditSupplementRoute) return !customEditSupplementRoute;
        if (field === 'Frequency' && otherEditSupplementFrequency) return !customEditSupplementFrequency;
        if (field === 'Metric' && otherEditSupplementMetric) return !customEditSupplementMetric;
        if (field === 'AmountExtra' && otherEditSupplementAmountExtra) return !customEditSupplementAmountExtra;
        return !values[field];
      });

      if (missingFields.length > 0) {
        message.error(`Please fill in all required fields: ${missingFields.join(', ')}`);
        return;
      }

      try {
        const payload = {
          id: editingSupplement.id,
          supplementName: values.SupplementName,
          dose: values.Dose,
          metric: otherEditSupplementMetric ? customEditSupplementMetric : values.Metric,
          amount: String(values.Amount),
          amountExtra: otherEditSupplementAmountExtra ? customEditSupplementAmountExtra : values.AmountExtra,
          route: otherEditSupplementRoute ? customEditSupplementRoute : values.Route,
          frequency: otherEditSupplementFrequency ? customEditSupplementFrequency : values.Frequency,
          notes: values.Notes,
        };

        const result = await dispatch(editPatientSupplement(payload));

        if (editPatientSupplement.fulfilled.match(result)) {
          message.success("Supplement updated successfully!");
          dispatch(getPatientSupplements(patient.userRef));
          closeEditSupplementModal();
        } else {
          message.error("Failed to update supplement. Please try again.");
        }
      } catch (error) {
        console.error('Error details:', error);
        message.error("Failed to update supplement. Please try again.");
      }
    }).catch((error) => {
      console.error('Form validation error:', error);
      message.error("Please check all required fields.");
    });
  };

  const handleDeleteSupplement = async (record) => {
    try {
      await dispatch(deletePatientSupplement(record.id)).unwrap();
      message.success("Supplement deleted successfully!");
      dispatch(getPatientSupplements(patient.userRef));
    } catch (error) {
      message.error("Failed to delete supplement.");
    }
  };

  const handleDelete = async (record, localIndex) => {
    try {
      // Check if it's a server medication (has id) or local medication
      if (record.id) {
        // Server medication - delete from server
        await dispatch(deletePatientMed(record.id)).unwrap();
        message.success("Medication deleted successfully!");
        dispatch(getPatientMed(patient.userRef));
      } else {
        // Local medication - remove from local state
        setLocalMedications(prev => prev.filter((_, idx) => idx !== localIndex));
        message.success("Medication removed successfully!");
      }
    } catch (error) {
      message.error("Failed to delete medication.");
    }
  };

  const handleEdit = (record) => {
    setEditingMedication(record);
    
    // Set the selected medication for the dropdowns to work properly
    const medicationName = record.drugName || record.medicationName;
    setSelectedMedication(medicationName);

    // Seed strength selection so the existing value shows as selected (not the custom builder)
    setSelectedStrength(record.strength || '');
    setCustomStrengthAmount('');
    setCustomStrengthUnit('');
    setOtherStrengthUnit(false);
    setCustomStrengthUnitText('');

    // Map backend field names to form field names
    const mappedRecord = {
      drugName: medicationName,
      strength: record.strength,
      route: record.route,
      dose: record.dose,
      frequency: record.frequency,
      duration: record.duration,
      quantity: record.amount || record.quantity, // Map 'amount' to 'quantity'
      refills: record.refills,
      notes: record.Note ?? record.note ?? '',
    };

    console.log('Setting form values:', mappedRecord);
    
    // Set form values after a small delay to ensure state is updated
    setTimeout(() => {
      editForm.setFieldsValue(mappedRecord);
      console.log('Form values set:', editForm.getFieldsValue());
    }, 100);
    
    setIsEditModalVisible(true);
  };

  const handleEditSubmit = () => {
    // Get all form values directly
    const formValues = editForm.getFieldsValue();
    console.log('Raw form values:', formValues);
    
    // Check if we have the required values
    if (!formValues.drugName || !formValues.strength || !formValues.route || !formValues.dose || !formValues.frequency || !formValues.duration || !formValues.quantity || !formValues.refills) {
      message.error("Please fill in all required fields");
      console.log('Missing required fields:', {
        drugName: !!formValues.drugName,
        strength: !!formValues.strength,
        route: !!formValues.route,
        dose: !!formValues.dose,
        frequency: !!formValues.frequency,
        duration: !!formValues.duration,
        quantity: !!formValues.quantity,
        refills: !!formValues.refills
      });
      return;
    }

    try {
      // Map form field names back to backend field names (capitalized)
      // Use custom text values when "Other (specify)" was selected
      const mappedValues = {
        drugName: formValues.drugName,
        strength: formValues.strength,
        route: otherRoute ? customRoute : formValues.route,
        dose: otherDose ? customDose : formValues.dose,
        frequency: otherFrequency ? customFrequency : formValues.frequency,
        duration: otherDuration ? customDuration : formValues.duration,
        amount: formValues.quantity.toString(),
        refills: formValues.refills,
        Note: formValues.notes || '',
      };

      console.log('Mapped values for API:', mappedValues);
      console.log('Editing medication ID:', editingMedication.id);

      const payload = {
        ...mappedValues,
        id: editingMedication.id,
      };

      console.log('Final payload:', payload);

      // Call the API
      dispatch(editPatientMed(payload)).then((result) => {
        if (editPatientMed.fulfilled.match(result)) {
          message.success("Medication updated successfully!");
          dispatch(getPatientMed(patient.userRef));
          setIsEditModalVisible(false);
          setSelectedMedication(null);
          editForm.resetFields();
        } else {
          message.error("Failed to update medication");
        }
      }).catch((error) => {
        console.error('API call failed:', error);
        message.error("Failed to update medication");
      });

    } catch (error) {
      console.error('Error in handleEditSubmit:', error);
      message.error("Failed to update medication");
    }
  };

  const exportToPDF = async () => {
    try {
      const doc = new jsPDF();
      
      // Get patient info
      const patientInfo = JSON.parse(localStorage.getItem('patient')) || {};
      const patientName = patientInfo.firstname ? `${patientInfo.firstname} ${patientInfo.lastname || ''}` : (patientInfo.name || patientInfo.fullName || patientInfo.patientName || '');
      const phn = patientInfo.phn || patientInfo.uli || patientInfo.phnUli || '';
      const address = patientInfo.address || patientInfo.city || '';
      const phone = patientInfo.phone || patientInfo.patientPhone || patientInfo.phoneNumber || '';
      const sex = (patientInfo.gender || patientInfo.Gender || patientInfo.sex || patientInfo.Sex || '').toLowerCase().startsWith('m') ? 'Male' : 'Female';
      let dob = patientInfo.dob || patientInfo.dateOfBirth || '';
      if (typeof dob === 'string' && dob.includes('T00:00:00')) {
        dob = dob.replace('T00:00:00', '').trim();
      }
      
      // Add header
      doc.setFontSize(20);
      doc.text('My Fertility Labs', 105, 20, { align: 'center' });
      
      // Add contact info
      doc.setFontSize(10);
      doc.text('Ph: 1-403-760-7017', 20, 30);
      doc.text('Fx: 1-825-902-8022', 20, 35);
      doc.text('Edmonton: 11444 17 Ave SW, Edmonton, AB, T6W 2S5', 20, 40);
      doc.text('Leduc: 6207 50 St #102, Leduc, AB T9E 7A9', 20, 45);
      doc.text('Calgary: Suite 280, 7015 Macleod Trail SW, Calgary, Alberta, T2H 2K6', 20, 50);
      
      // Add patient info
      doc.setFontSize(12);
      doc.text(`Patient Name: ${patientName}`, 20, 65);
      doc.text(`PHN (ULI): ${phn}`, 120, 65);
      doc.text(`Address: ${address}`, 20, 75);
      doc.text(`Patient Phone: ${phone}`, 20, 85);
      doc.text(`Sex: ${sex}`, 120, 85);
      doc.text(`DOB: ${dob}`, 180, 85);
      
      // Add RX section
      doc.setFontSize(16);
      doc.text('RX', 20, 105);
      doc.setFontSize(12);
      doc.text(`Date Prescribed: ${new Date().toLocaleDateString()}`, 60, 105);
      
      // Add medications table
      const medicationsData = [...(serverMedications || []), ...(localMedications || [])];
      let tableResult = null;
      if (medicationsData.length > 0) {
        const tableData = medicationsData.map(med => [
          med.drugName || 'N/A',
          med.strength || 'N/A',
          med.dose || 'N/A',
          med.frequency || 'N/A',
          med.duration || 'N/A',
          med.amount || 'N/A',
          med.refills || 'N/A',
          med.Note ?? med.note ?? ''
        ]);

        tableResult = autoTable(doc, {
          head: [['Medication', 'Strength', 'Dose', 'Frequency', 'Duration', 'Quantity', 'Refills', 'Notes']],
          body: tableData,
          startY: 120,
          styles: {
            fontSize: 10,
            cellPadding: 3
          },
          headStyles: {
            fillColor: [26, 60, 107],
            textColor: 255
          },
          columnStyles: {
            0: { cellWidth: 30 },
            1: { cellWidth: 20 },
            2: { cellWidth: 20 },
            3: { cellWidth: 25 },
            4: { cellWidth: 20 },
            5: { cellWidth: 15 },
            6: { cellWidth: 15 },
            7: { cellWidth: 35 }
          }
        });
      }

      // Add prescriber info
      const finalY = tableResult ? tableResult.finalY + 20 : 200;
      doc.setFontSize(12);
      doc.text(`Prescriber's Name: ${userProfileData.firstName || ''} ${userProfileData.lastName || ''}`, 20, finalY);
      doc.text(`Designation: ${userProfileData.designation || ''}`, 20, finalY + 8);
      doc.text(`License Number: ${userProfileData.licenceNumber || ''}`, 20, finalY + 16);
      doc.text(`Phone: ${userProfileData.phoneNumber || ''}`, 20, finalY + 24);
      
      // Add signature image if available
      if (userProfileData.signature) {
        const sigData = await fetchImageDataUrl(userProfileData.signature);
        if (sigData) {
          try {
            const imgProps = doc.getImageProperties(sigData);
            const imgWidth = 60;
            const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
            // place signature on right side
            doc.addImage(sigData, imgProps.fileType || 'PNG', 140, finalY, imgWidth, imgHeight);
          } catch (err) {
            console.warn('Failed to add signature image to PDF:', err);
            // fallback: draw signature line
            doc.line(140, finalY + 30, 220, finalY + 30);
            doc.text('Signature', 140, finalY + 36);
          }
        } else {
          doc.line(180, finalY + 30, 250, finalY + 30);
        }
      } else {
        // signature missing -> draw signature line
        doc.line(180, finalY + 30, 250, finalY + 30);
      }
      
      // Save the PDF
      doc.save(`prescription_${patientName.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`);
      message.success('Prescription PDF exported successfully!');
    } catch (error) {
      console.error('Error exporting PDF:', error);
      message.error('Failed to export PDF');
    }
  };

  // Generate prescription PDF and return base64 + suggested filename and title
  const generatePrescriptionPDFBase64 = async () => {
    try {
      const doc = new jsPDF();

      // Get patient info
      const patientInfo = JSON.parse(localStorage.getItem('patient')) || {};
      const patientName = patientInfo.firstname ? `${patientInfo.firstname} ${patientInfo.lastname || ''}` : (patientInfo.name || patientInfo.fullName || patientInfo.patientName || 'Patient');
      const phn = patientInfo.phn || patientInfo.uli || patientInfo.phnUli || '';
      const address = patientInfo.address || patientInfo.city || '';
      const phone = patientInfo.phone || patientInfo.patientPhone || patientInfo.phoneNumber || '';
      const sex = (patientInfo.gender || patientInfo.Gender || patientInfo.sex || patientInfo.Sex || '').toLowerCase().startsWith('m') ? 'Male' : 'Female';
      let dob = patientInfo.dob || patientInfo.dateOfBirth || '';
      if (typeof dob === 'string' && dob.includes('T00:00:00')) {
        dob = dob.replace('T00:00:00', '').trim();
      }

      // Header
      doc.setFontSize(20);
      doc.text('My Fertility Labs', 105, 20, { align: 'center' });

      // Contact info
      doc.setFontSize(12);
      doc.text('Ph: 1-403-760-7017    Fx: 1-825-902-8022', 105, 28, { align: 'center' });

      // Patient details
      doc.setFontSize(14);
      doc.text('Patient Information', 14, 40);
      doc.setFontSize(12);
      doc.text(`Name: ${patientName}`, 14, 48);
      if (dob) doc.text(`DOB: ${dob}`, 120, 48);
      if (sex) doc.text(`Sex: ${sex}`, 14, 56);
      if (phn) doc.text(`PHN/ULI: ${phn}`, 120, 56);
      if (address) doc.text(`Address: ${address}`, 14, 64);
      if (phone) doc.text(`Phone: ${phone}`, 14, 72);

      // Prescriptions table header
      doc.setFontSize(14);
      doc.text('Prescriptions', 14, 86);
      doc.setFontSize(12);

      // Render medications list from current table state (serverMedications)
      let y = 94;
      const meds = Array.isArray(serverMedications) ? serverMedications : [];
      if (meds.length === 0) {
        doc.text('No prescriptions available.', 14, y);
        y += 8;
      } else {
        // Table headers
        doc.text('Medication', 14, y);
        doc.text('Strength', 84, y);
        doc.text('Route', 124, y);
        doc.text('Dose', 154, y);
        doc.text('Frequency', 184, y);
        y += 6;
        doc.setDrawColor(200);
        doc.line(12, y, 198, y);
        y += 6;

        meds.forEach((m) => {
          const medName = m.drugName || m.medicationName || '';
          const strength = m.strength || '';
          const route = m.route || '';
          const dose = m.dose || '';
          const freq = m.frequency || '';

          doc.text(String(medName).substring(0, 30), 14, y);
          doc.text(String(strength).substring(0, 18), 84, y);
          doc.text(String(route).substring(0, 18), 124, y);
          doc.text(String(dose).substring(0, 18), 154, y);
          doc.text(String(freq).substring(0, 22), 184, y);
          y += 6;
          if (y > 270) {
            doc.addPage();
            y = 20;
          }

          const mNote = m.Note ?? m.note;
          if (mNote && String(mNote).trim()) {
            doc.setFontSize(9);
            const noteLines = doc.splitTextToSize(`Notes: ${mNote}`, 180);
            doc.text(noteLines, 18, y);
            y += noteLines.length * 4;
            doc.setFontSize(12);
            if (y > 270) {
              doc.addPage();
              y = 20;
            }
          }
        });
      }

      // Footer
      if (y < 270) y = 270;
      doc.setFontSize(10);
      const printedOn = new Date();
      const dateStr = `${printedOn.getFullYear()}-${String(printedOn.getMonth()+1).padStart(2,'0')}-${String(printedOn.getDate()).padStart(2,'0')}`;
      doc.text(`Generated on ${dateStr}`, 14, y);

      // Add prescriber license and signature at bottom
      const sigY = y + 12;
      doc.setFontSize(11);
      doc.text(`Prescriber's Name: ${userProfileData.firstName || ''} ${userProfileData.lastName || ''}`, 14, sigY);
      doc.text(`License Number: ${userProfileData.licenceNumber || ''}`, 14, sigY + 8);

      if (userProfileData.signature) {
        const sigData = await fetchImageDataUrl(userProfileData.signature);
        if (sigData) {
          try {
            const imgProps = doc.getImageProperties(sigData);
            const imgWidth = 60;
            const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
            doc.addImage(sigData, imgProps.fileType || 'PNG', 140, sigY - 6, imgWidth, imgHeight);
          } catch (err) {
            console.warn('Failed to add signature image to generated PDF:', err);
            doc.line(140, sigY + 18, 200, sigY + 18);
            doc.text('Signature', 140, sigY + 24);
          }
        } else {
          doc.line(140, sigY + 18, 200, sigY + 18);
        }
      } else {
        doc.line(140, sigY + 18, 200, sigY + 18);
      }

      // Output as data URI string and extract base64
      const dataUri = doc.output('datauristring');
      const base64 = dataUri.split(',')[1];
      const safeName = (patientName || 'Patient').replace(/[^a-z0-9]+/gi, '_').replace(/_+/g, '_');
      const filename = `Medication_${safeName}_${dateStr}.pdf`;
      const fileTitle = `Medication for ${patientName}`;

      return { base64, filename, fileTitle };
    } catch (err) {
      console.error('Error generating PDF base64:', err);
      return { base64: '', filename: 'Medication.pdf', fileTitle: 'Medication' };
    }
  };




  const PrescriptionPreview = ({ patientInfo }) => {
    // Fallback to localStorage if prop not provided
    const info = patientInfo || JSON.parse(localStorage.getItem('patient')) || {};
    console.log('PrescriptionPreview patientInfo:', info);
    const patientName = info.firstname ? `${info.firstname} ${info.lastname || ''}` : (info.name || info.fullName || info.patientName || '');
    const phn = info.phn || info.uli || info.phnUli || '';
    const address = info.address || info.city || '';
    const phone = info.phone || info.patientPhone || info.phoneNumber || '';
    const sex = (info.gender || info.Gender || info.sex || info.Sex || '').toLowerCase().startsWith('m') ? 'Male' : 'Female';
    let dob = info.dob || info.dateOfBirth || '';
    if (typeof dob === 'string' && dob.includes('T00:00:00')) {
      dob = dob.replace('T00:00:00', '').trim();
    }
    return (
      <div style={{ background: '#fff', padding: 32, minHeight: 900, fontFamily: 'Arial, sans-serif', position: 'relative' }}>
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <img src={fertilityLogo} alt="MyFertility Labs" style={{ height: 48 }} />
          <div style={{ textAlign: 'right', fontSize: 13 }}>
            <b>My Fertility Labs</b><br />
            Ph: 1-403-760-7017<br />
            Fx: 1-825-902-8022
          </div>
        </div>
        <div style={{ fontSize: 12, margin: '12px 0 0 0' }}>
          Edmonton: 11444 17 Ave SW, Edmonton, AB, T6W 2S5<br />
          Leduc: 6207 50 St #102, Leduc, AB T9E 7A9<br />
          Calgary: Suite 280, 7015 Macleod Trail SW, Calgary, Alberta, T2H 2K6
        </div>
     
        <div style={{ marginTop: 18, fontSize: 14 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '2px solid #222', paddingBottom: 4 }}>
            <span><b>Patient Name:</b> {patientName}</span>
            <span><b>PHN (ULI):</b> {phn}</span>
          </div>
          <div style={{ borderBottom: '2px solid #222', padding: '4px 0' }}>
            <b>Address:</b> {address}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '2px solid #222', padding: '4px 0' }}>
            <span><b>Patient Phone:</b> {phone}</span>
            <span><b>Sex:</b> {sex}</span>
            <span><b>DOB:</b> {dob}</span>
          </div>
        </div>

        <div style={{ display: 'flex', marginTop: 32 }}>
          <div style={{ fontSize: 64, fontWeight: 'bold', color: '#1a3c6b', marginRight: 32, marginTop: -12 }}>RX</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 'bold', marginBottom: 8 }}>Date Prescribed: {new Date().toLocaleDateString()}</div>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: '#eaf6fa' }}>
                  <th style={{ border: '1px solid #ccc', padding: 4 }}>Medication</th>
                  <th style={{ border: '1px solid #ccc', padding: 4 }}>Strength</th>
                  <th style={{ border: '1px solid #ccc', padding: 4 }}>Dose</th>
                  <th style={{ border: '1px solid #ccc', padding: 4 }}>Frequency</th>
                  <th style={{ border: '1px solid #ccc', padding: 4 }}>Duration</th>
                  <th style={{ border: '1px solid #ccc', padding: 4 }}>Quantity</th>
                  <th style={{ border: '1px solid #ccc', padding: 4 }}>Refills</th>
                  <th style={{ border: '1px solid #ccc', padding: 4 }}>Notes</th>
                </tr>
              </thead>
              <tbody>
                {serverMedications?.map((med, idx) => (
                  <tr key={idx}>
                    <td style={{ border: '1px solid #ccc', padding: 4 }}>{med.drugName}</td>
                    <td style={{ border: '1px solid #ccc', padding: 4 }}>{med.strength}</td>
                    <td style={{ border: '1px solid #ccc', padding: 4 }}>{med.dose}</td>
                    <td style={{ border: '1px solid #ccc', padding: 4 }}>{med.frequency}</td>
                    <td style={{ border: '1px solid #ccc', padding: 4 }}>{med.duration}</td>
                    <td style={{ border: '1px solid #ccc', padding: 4 }}>{med.amount}</td>
                    <td style={{ border: '1px solid #ccc', padding: 4 }}>{med.refills}</td>
                    <td style={{ border: '1px solid #ccc', padding: 4, whiteSpace: 'pre-wrap' }}>{med.Note ?? med.note}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {/* Prescriber Info and Signature */}
        <div style={{ position: 'absolute', left: 0, bottom: 32, width: '100%' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
            <div style={{ fontSize: 13 }}>
              {console.log('User profile data:', userProfileData)}
              <b>Prescriber's Name: {userProfileData.firstName} {userProfileData.lastName}</b><br />
              Designation: {userProfileData.designation}<br />
              License Number: {userProfileData.licenceNumber}<br />
              Phone: {userProfileData.phoneNumber}
            </div>
            <div style={{ textAlign: 'center', fontSize: 13 }}>
              {userProfileData?.signature ? (
                <img 
                  src={userProfileData?.signature} 
                  alt="Signature" 
                  style={{ 
                    width: 220, 
                    height: 60, 
                    objectFit: 'contain',
                    borderBottom: '1px solid #222',
                  }} 
                />
              ) : (
                <div style={{ borderBottom: '1px solid #222', width: 220, marginBottom: 4, marginLeft: 'auto' }}>
                  Signature (No image loaded)
                </div>
              )}
              {/* Debug info */}
              <div style={{ fontSize: 10, color: '#666', marginTop: 5 }}>
                Signature
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const isMobile = useMediaQuery({ maxWidth: 767 });
  const medicationColumns = [
    { title: 'Name', dataIndex: 'drugName', key: 'drugName', align: 'center' },
    { title: 'Strength', dataIndex: 'strength', key: 'strength', align: 'center' },
    { title: 'Route', dataIndex: 'route', key: 'route', align: 'center' },
    { title: 'Dose', dataIndex: 'dose', key: 'dose', align: 'center' },
    { title: 'Frequency', dataIndex: 'frequency', key: 'frequency', align: 'center' },
    { title: 'Duration', dataIndex: 'duration', key: 'duration', align: 'center' },
    { title: 'Quantity', dataIndex: 'amount', key: 'amount', align: 'center' },
    { title: 'Refills', dataIndex: 'refills', key: 'refills', align: 'center' },
    { title: 'Notes', key: 'Note', align: 'center', render: (_, record) => record.Note ?? record.note ?? '' },
    {
      title: 'Actions',
      key: 'actions',
      align: 'center',
      render: (_, record, index) => {
        // Calculate if this is a server medication or local medication
        const isServerMedication = record.id;
        const localIndex = isServerMedication ? null : index - serverMedications.length;
        
        return (
          <>
            <Button
              type="link"
              icon={<EditOutlined />}
              onClick={() => isServerMedication ? handleEdit(record) : handleEditLocal(record, localIndex)}
            >
              Edit
            </Button>
            <Button
              type="link"
              danger
              icon={<DeleteOutlined />}
              onClick={() => handleDelete(record, localIndex)}
            >
              Delete
            </Button>
          </>
        );
      },
    },
  ];

  const supplementColumns = [
    {
      title: "Name",
      dataIndex: "supplementName",
      key: "name",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "Dose",
      dataIndex: "dose",
      key: "dose",
    },
    {
      title: "Metric",
      dataIndex: "metric",
      key: "metric",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Route",
      dataIndex: "route",
      key: "route",
    },
    {
      title: "Frequency",
      dataIndex: "frequency",
      key: "frequency",
    },
    {
      title: "Notes",
      dataIndex: "notes",
      key: "notes",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => handleEditSupplement(record)}
          >
            Edit
          </Button>
          <Button
            type="link"
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDeleteSupplement(record)}
          >
            Delete
          </Button>
        </>
      ),
    },
  ];

  const items = [
    {
      key: "medications",
      label: "Medications",
      children: (
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              marginBottom: "20px",
              cursor: "pointer",
            }}
            onClick={showAddModal}
          >
            <PlusOutlined style={{ fontSize: "16px", color: "#1890ff" }} />
            <Text strong>Add New Medication</Text>
          </div>
          {console.log('Table dataSource:', [...(serverMedications || []), ...(localMedications || [])])}
          {console.log('serverMedications:', serverMedications)}
          {console.log('localMedications:', localMedications)}
          <Table
            dataSource={[...(serverMedications || []), ...(localMedications || [])]}
            columns={medicationColumns}
            pagination={false}
          />
        </>
      ),
    },
    {
      key: "supplements",
      label: "Supplements",
      children: (
        <>
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor: "pointer",
              }}
              onClick={showAddSupplementModal}
            >
              <PlusOutlined style={{ fontSize: "16px", color: "#1890ff" }} />
              <Text strong>Add New Supplement</Text>
            </div>
            
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              onClick={exportToPDF}
              style={{ 
                background: '#52c41a',
                borderColor: '#52c41a',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              Export to PDF
            </Button>
          </div>
          <Table
            dataSource={supplements}
            columns={supplementColumns}
            pagination={false}
          />
        </>
      ),
    },
    {
      key: "Prescriptions",
      label: "Prescriptions",
      children: (
        <>
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor: "pointer",
              }}
              onClick={showAddPrecriptionModal}
            >
              <Button
                type="primary"
                style={{ background: "#00ADEF", maxWidth: "200px" }}
                onClick={() => setIsUploadModalVisible(true)}
              >
                + Add New Prescription
              </Button>
            </div>
            
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              onClick={exportToPDF}
              style={{ 
                background: '#52c41a',
                borderColor: '#52c41a',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              Export to PDF
            </Button>
          </div>
          <Card style={{ border: "1px solid #C2E6F8", marginBottom: "24px" }}>
            <Typography.Title level={5} style={{ marginBottom: "16px" }}>
              Prescriptions
            </Typography.Title>
            <List
              dataSource={prescriptionFiles || []}
              renderItem={(file) => (
                <List.Item style={{ padding: '16px 0' }}>
                  <div style={{ display: "flex", alignItems: "center", width: "100%", gap: "16px" }}>
                    <div style={{ width: "3px", height: "40px", backgroundColor: "#00ADEF", flexShrink: 0 }} />
                    <div style={{ flex: "1" }}>
                      <Text>{file.filename || file.fileTitle}</Text>
                    </div>
                    <div style={{ flex: "1" }}>
                      <Text>{moment(file.createdOn).format("MMMM DD, YYYY")}</Text>
                    </div>
                    <div style={{ flex: "1", display: "flex", alignItems: "center", gap: 8 }}>
                      {getFileIcon(file.filename)}
                      <Link onClick={() => handleDownload(file.fileRef, file.filename)} style={{ color: "#1890ff" }}>
                        Download
                      </Link>
                    </div>
                    <Link
                      style={{ color: "#1890ff" }}
                      onClick={() => handleFaxToPharmacy(file.fileRef, file.filename)}
                    >
                      Send By Fax
                    </Link>

                    {/* <DeleteOutlined
                      style={{ color: "red", cursor: "pointer" }}
                      onClick={() => handleDelete(file.fileRef)}
                    /> */}
                  </div>
                </List.Item>
              )}
            />
          </Card>


        </>
      ),
    },
    {
      key: "prescriptionPreview",
      label: "Prescription Preview",
      children: (
        <>
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}>
            <Typography.Title level={4} style={{ margin: 0 }}>
              Prescription Preview
            </Typography.Title>
            
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              onClick={exportToPDF}
              style={{ 
                background: '#52c41a',
                borderColor: '#52c41a',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              Export to PDF
            </Button>
          </div>
          
          <div style={{ 
            border: '1px solid #d9d9d9', 
            borderRadius: '8px', 
            padding: '20px',
            backgroundColor: '#fafafa'
          }}>
            <PrescriptionPreview patientInfo={patient} />
          </div>
        </>
      ),
    },
  ];

  const FREQUENCY_TO_DOSES_PER_DAY = {
    'Once daily': 1,
    'Twice daily': 2,
    'Three times daily': 3,
    'Every 4 hours': 6,
    'Every 6 hours': 4,
    'Every 8 hours': 3,
    'Every 12 hours': 2,
    'Once weekly': 1/7,
    'Every other day': 0.5,
    'As needed (PRN)': 1, // default, can be overridden
    'One-time dose': 1,
    'Other': 1
  };

  // Helper to extract days from duration string
  // function getDurationInDays(duration) {
  //   if (!duration) return 1;
  //   const lower = duration.toLowerCase();
  //   if (lower.includes('day')) return parseInt(lower);
  //   if (lower.includes('week')) return parseInt(lower) * 7;
  //   if (lower.includes('month')) return parseInt(lower) * 30;
  //   return parseInt(duration) || 1;
  // }

  // State for PRN max per day
  const [prnMax, setPrnMax] = useState(1);

  // State for pharmacy confirmation modal
  const [pharmacyModalVisible, setPharmacyModalVisible] = useState(false);
  const [selectedFileForFax, setSelectedFileForFax] = useState(null);
  const [faxLoading, setFaxLoading] = useState(false);

  // RxNorm API search function
  const handleRxnormSearch = async (query) => {
    // Trigger search from first character to support immediate narrowing (e.g., "c", then "cl")
    if (!query || query.trim().length < 1) {
      setRxnormSuggestions([]);
      return;
    }

    setIsSearchingRxnorm(true);

    try {
      const suggestions = await getMedicationSuggestions(query, 15);
      setRxnormSuggestions(suggestions || []);
      // Auto-switch to custom input when no RxNorm results found
      if ((!suggestions || suggestions.length === 0) && query.trim().length >= 2) {
        setShowCustomMedicationInput(true);
        setCustomMedicationName(query.trim());
      }
    } catch (error) {
      console.error('RxNorm search error:', error);
      setRxnormSuggestions([]);
      setShowCustomMedicationInput(true);
      setCustomMedicationName(query.trim());
    } finally {
      setIsSearchingRxnorm(false);
    }
  };

  // Debounced route resolution for direct medication name input
  const handleMedicationNameChange = (value) => {
    if (value && value.trim().length > 2) {
      // Use debounced route resolution for direct medication name input
      getMedicationRoutesDebounced(value.trim(), (routes) => {
        if (routes && routes.length > 0) {
          setRxnormRoutes(routes);
          setSelectedRxnormMedication({ value: value.trim() });
        } else {
          setRxnormRoutes([]);
          setSelectedRxnormMedication(null);
        }
      }, 300);
    } else {
      setRxnormRoutes([]);
      setSelectedRxnormMedication(null);
    }
  };

  // Handle medication selection from RxNorm
  const handleRxnormMedicationSelect = (medication) => {
    setSelectedRxnormMedication(medication);
    setSelectedMedication(medication.value); // Use cleaned name (medication.value)
    form.setFieldsValue({ drugName: medication.value }); // Use cleaned name
    setRxnormSuggestions([]);
    // Load available routes using enhanced resolver with medication name
    if (medication?.value) {
      getMedicationRoutes(medication.value).then((routes) => {
        setRxnormRoutes(routes || []);
      }).catch(() => setRxnormRoutes([]));
      // Load available strengths as well
      getMedicationStrengths(medication.rxcui).then((strengths) => {
        setRxnormStrengths(strengths || []);
      }).catch(() => setRxnormStrengths([]));
    } else {
      setRxnormRoutes([]);
      setRxnormStrengths([]);
    }
  };

  // Handle fax to pharmacy
  const handleFaxToPharmacy = (fileRef, fileName) => {
    setSelectedFileForFax({ fileRef, fileName });
    setPharmacyModalVisible(true);
  };

  const handlePharmacyConfirm = async (pharmacyData, fileRef, fileName) => {
    setFaxLoading(true);
    try {
      // Generate PDF preview and get base64
      const { base64, filename, fileTitle } = await generatePrescriptionPDFBase64();

      // Gather identifiers
      const patientInfo = JSON.parse(localStorage.getItem('patient')) || {};
      const patientRef = patientInfo.userRef || patientInfo.userref || patientInfo.UserRef || '';

      // Build payload
      const payload = {
        patientRef: patientRef,
        document: [
          {
            base64: base64,
            filename: filename,
            fileTitle: fileTitle,
            fileType: 3
          }
        ],
        sendFax: true,
        medId: 0
      };

      // Auth token
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      const token = userInfo?.token || userInfo?.obj?.token;

      const res = await fetch(`${baseUrl}Doctor/SendPatientMedToPharmacy`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {})
        },
        body: JSON.stringify(payload)
      });

      if (!res.ok) {
        const text = await res.text().catch(() => '');
        throw new Error(`API error ${res.status}: ${text}`);
      }

      message.success(`Fax sent successfully to ${pharmacyData?.name || 'pharmacy'}`);
      setPharmacyModalVisible(false);
      setSelectedFileForFax(null);
    } catch (error) {
      console.error('Error sending fax:', error);
      message.error('Failed to send fax. Please try again.');
    } finally {
      setFaxLoading(false);
    }
  };

  const handlePharmacyCancel = () => {
    setPharmacyModalVisible(false);
    setSelectedFileForFax(null);
  };

  // Helper to generate dose options based on strength and route
  function getDoseOptions(strength, route) {
    if (!strength) return [];
    
    // First check if we have predefined options for this route
    if (route && ROUTE_STRENGTH_MAP[route]) {
      return ROUTE_STRENGTH_MAP[route].map(dose => ({
        label: dose,
        value: dose
      }));
    }
    
    // Fallback to strength-based calculation
    const solidMatch = strength.match(/([\d.]+)\s*(mg|mcg|IU|g|mEq|unit|units|tablet|tab|capsule|cap|patch|suppository|spray|drop|chewable|lozenge|film|wafer|puff|mcg\/hr|mg\/hr|mg\/patch|mcg\/patch|mg\/tab|mg\/cap|mg\/suppository|mg\/spray|mg\/drop|mg\/chewable|mg\/lozenge|mg\/film|mg\/wafer|mg\/puff|mcg\/hr|g\/kg|mg\/kg)?/i);
    const liquidMatch = strength.match(/([\d.]+)\s*(mg|mcg|IU|g|mEq|unit|units)\s*\/\s*([\d.]+)\s*(mL|ml)/i);
    const comboMatch = strength.match(/([\d.]+)\s*(mg|mcg|g|mEq|unit|units)\s*\/\s*([\d.]+)\s*(mg|mcg|g|mEq|unit|units)/i);
    const patchMatch = strength.match(/([\d.]+)\s*mcg\/hr\s*patch/i);
    const percentMatch = strength.match(/([\d.]+)%/);
    let options = [];
    if (liquidMatch) {
      // e.g., 100 mg/5 mL
      const mg = parseFloat(liquidMatch[1]);
      const perMl = parseFloat(liquidMatch[3]);
      for (let i = 0.5; i <= 5; i += 0.5) {
        const dose = (mg / perMl) * i;
        options.push({ label: `${i} mL (${dose} ${liquidMatch[2]})`, value: `${i} mL` });
      }
    } else if (patchMatch) {
      for (let i = 1; i <= 3; i++) {
        options.push({ label: `${i} patch${i > 1 ? 'es' : ''} (${patchMatch[1]} mcg/hr each)`, value: `${i} patch` });
      }
    } else if (percentMatch) {
      for (let i = 1; i <= 3; i++) {
        options.push({ label: `${i} application${i > 1 ? 's' : ''} (${percentMatch[1]}%)`, value: `${i} application` });
      }
    } else if (comboMatch) {
      for (let i = 0.25; i <= 3; i += 0.25) {
        options.push({ label: `${i} tablet${i !== 1 ? 's' : ''} (${i * parseFloat(comboMatch[1])} ${comboMatch[2]} / ${i * parseFloat(comboMatch[3])} ${comboMatch[4]})`, value: `${i} tablet` });
      }
    } else if (solidMatch) {
      const base = parseFloat(solidMatch[1]);
      const unit = solidMatch[2] || 'unit';
      for (let i = 0.25; i <= 3; i += 0.25) {
        options.push({ label: `${i} ${unit}${i !== 1 ? 's' : ''} (${i * base} ${unit})`, value: `${i} ${unit}` });
      }
    }
    return options;
  }




  // const PrescriptionPreview = ({ patientInfo }) => {
  //   // Fallback to localStorage if prop not provided
  //   const info = patientInfo || JSON.parse(localStorage.getItem('patient')) || {};
  //   console.log('PrescriptionPreview patientInfo:', info);
  //   const patientName = info.firstname ? `${info.firstname} ${info.lastname || ''}` : (info.name || info.fullName || info.patientName || '');
  //   const phn = info.phn || info.uli || info.phnUli || '';
  //   const address = info.address || info.city || '';
  //   const phone = info.phone || info.patientPhone || info.phoneNumber || '';
  //   const sex = 'Female';
  //   let dob = info.dob || info.dateOfBirth || '';
  //   if (typeof dob === 'string' && dob.includes('T00:00:00')) {
  //     dob = dob.replace('T00:00:00', '').trim();
  //   }
  //   return (
  //     <div style={{ background: '#fff', padding: 32, minHeight: 900, fontFamily: 'Arial, sans-serif', position: 'relative' }}>
  //       {/* Header */}
  //       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
  //         <img src={fertilityLogo} alt="MyFertility Labs" style={{ height: 48 }} />
  //         <div style={{ textAlign: 'right', fontSize: 13 }}>
  //           <b>My Fertility Labs</b><br />
  //           Ph: 1-403-760-7017<br />
  //           Fx: 1-825-902-8022
  //         </div>
  //       </div>
  //       <div style={{ fontSize: 12, margin: '12px 0 0 0' }}>
  //         Edmonton: 11444 17 Ave SW, Edmonton, AB, T6W 2S5<br />
  //         Leduc: 6207 50 St #102, Leduc, AB T9E 7A9<br />
  //         Calgary: Suite 280, 7015 Macleod Trail SW, Calgary, Alberta, T2H 2K6
  //       </div>
  //       {/* Patient Info */}
  //       <div style={{ marginTop: 18, fontSize: 14 }}>
  //         <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '2px solid #222', paddingBottom: 4 }}>
  //           <span><b>Patient Name:</b> {patientName}</span>
  //           <span><b>PHN (ULI):</b> {phn}</span>
  //         </div>
  //         <div style={{ borderBottom: '2px solid #222', padding: '4px 0' }}>
  //           <b>Address:</b> {address}
  //         </div>
  //         <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '2px solid #222', padding: '4px 0' }}>
  //           <span><b>Patient Phone:</b> {phone}</span>
  //           <span><b>Sex:</b> {sex}</span>
  //           <span><b>DOB:</b> {dob}</span>
  //         </div>
  //       </div>
  //       {/* RX and Medications */}
  //       <div style={{ display: 'flex', marginTop: 32 }}>
  //         <div style={{ fontSize: 64, fontWeight: 'bold', color: '#1a3c6b', marginRight: 32, marginTop: -12 }}>RX</div>
  //         <div style={{ flex: 1 }}>
  //           <div style={{ fontWeight: 'bold', marginBottom: 8 }}>Date Prescribed: {new Date().toLocaleDateString()}</div>
  //           <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
  //             <thead>
  //               <tr style={{ background: '#eaf6fa' }}>
  //                 <th style={{ border: '1px solid #ccc', padding: 4 }}>Medication</th>
  //                 <th style={{ border: '1px solid #ccc', padding: 4 }}>Strength</th>
  //                 <th style={{ border: '1px solid #ccc', padding: 4 }}>Dose</th>
  //                 <th style={{ border: '1px solid #ccc', padding: 4 }}>Frequency</th>
  //                 <th style={{ border: '1px solid #ccc', padding: 4 }}>Duration</th>
  //                 <th style={{ border: '1px solid #ccc', padding: 4 }}>Quantity</th>
  //                 <th style={{ border: '1px solid #ccc', padding: 4 }}>Refills</th>
  //               </tr>
  //             </thead>
  //             <tbody>
  //               {serverMedications?.map((med, idx) => (
  //                 <tr key={idx}>
  //                   <td style={{ border: '1px solid #ccc', padding: 4 }}>{med.drugName}</td>
  //                   <td style={{ border: '1px solid #ccc', padding: 4 }}>{med.strength}</td>
  //                   <td style={{ border: '1px solid #ccc', padding: 4 }}>{med.dose}</td>
  //                   <td style={{ border: '1px solid #ccc', padding: 4 }}>{med.frequency}</td>
  //                   <td style={{ border: '1px solid #ccc', padding: 4 }}>{med.duration}</td>
  //                   <td style={{ border: '1px solid #ccc', padding: 4 }}>{med.amount}</td>
  //                   <td style={{ border: '1px solid #ccc', padding: 4 }}>{med.refills}</td>
  //                 </tr>
  //               ))}
  //             </tbody>
  //           </table>
  //         </div>
  //       </div>
  //       {/* Prescriber Info and Signature */}
  //       <div style={{ position: 'absolute', left: 0, bottom: 32, width: '100%' }}>
  //         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
  //           <div style={{ fontSize: 13 }}>
  //             <b>Prescriber's Name: {userProfileData.firstName} {userProfileData.lastName}</b><br />
  //             Designation: {userProfileData.designation}<br />
  //             License Number: {userProfileData.licenceNumber}<br />
  //             Phone: {userProfileData.phoneNumber}
  //           </div>
  //           <div style={{ textAlign: 'center', fontSize: 13 }}>
  //             <div style={{ borderBottom: '1px solid #222', width: 220, marginBottom: 4, marginLeft: 'auto' }}></div>
  //             Signature
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };


  const normalizeUnit = (u) => (u || '').toLowerCase().replace(/s$/,'');

  const parseAmount = (text) => {
    if (!text) return { value: NaN, unit: '' };
    const str = String(text).toLowerCase();
    // patterns like "50 mg/mL" or "10000 units/mL"
    const conc = str.match(/([\d.]+)\s*(mcg|mg|g|iu|units)\s*\/(\s*)(ml|mL)/i);
    if (conc) {
      return {
        kind: 'concentration',
        numValue: parseFloat(conc[1]),
        numUnit: normalizeUnit(conc[2]).replace('units', 'iu'),
        denUnit: 'ml'
      };
    }
    // patterns like "0.5 mg per spray"
    const perX = str.match(/([\d.]+)\s*(mcg|mg|g|iu|units)\s*per\s*([a-zA-Z]+)/i);
    if (perX) {
      return {
        kind: 'concentration',
        numValue: parseFloat(perX[1]),
        numUnit: normalizeUnit(perX[2]).replace('units', 'iu'),
        denUnit: normalizeUnit(perX[3])
      };
    }
    // plain amount like "100 mg" or volume like "2 mL"
    const amt = str.match(/([\d.]+)\s*(mcg|mg|g|iu|units|ml)/i);
    if (amt) {
      const unit = normalizeUnit(amt[2]).replace('units', 'iu');
      return { kind: unit === 'ml' ? 'volume' : 'mass', value: parseFloat(amt[1]), unit };
    }
    return { value: NaN, unit: '', kind: 'unknown' };
  };

  // Recalculate quantity using current form values. Use in places where we update strength programmatically
  const recalcQuantityFromForm = (formInstance) => {
    try {
      const all = formInstance.getFieldsValue([
        'strength', 'dose', 'frequency', 'duration'
      ]);
      const { strength, dose, frequency, duration } = all || {};

      let dosesPerDay = FREQUENCY_TO_DOSES_PER_DAY[frequency] || 1;
      let days = 1;

      if (typeof duration === 'string') {
        const dayMatch = duration.match(/(\d+)\s*day/);
        const weekMatch = duration.match(/(\d+)\s*week/);
        const monthMatch = duration.match(/(\d+)\s*month/);
        if (dayMatch) days = parseInt(dayMatch[1]);
        else if (weekMatch) days = parseInt(weekMatch[1]) * 7;
        else if (monthMatch) days = parseInt(monthMatch[1]) * 30;
        else if (!isNaN(Number(duration))) days = Number(duration);
      }

      if (frequency === 'As needed (PRN)') {
        dosesPerDay = prnMax || 1;
      }

      if (frequency === 'Once weekly') {
        days = Math.ceil(days / 7);
      }

      const s = parseAmount(strength);
      const d = parseAmount(dose);

      const computeUnitsPerDose = () => {
        if (!s || !d) return NaN;
        if (s.kind === 'concentration') {
          if (d.kind === 'mass') {
            const doseMg = massToMg(d.value, d.unit);
            const perMlMg = massToMg(s.numValue, s.numUnit);
            if (isNaN(doseMg) || isNaN(perMlMg) || perMlMg <= 0) return NaN;
            return doseMg / perMlMg;
          }
          if (d.kind === 'volume' && normalizeUnit(s.denUnit) === normalizeUnit(d.unit)) {
            return d.value;
          }
          return NaN;
        }
        if (s.kind === 'mass') {
          if (d.kind !== 'mass') return NaN;
          const doseMg = massToMg(d.value, d.unit);
          const strengthMg = massToMg(s.value, s.unit);
          if (isNaN(doseMg) || isNaN(strengthMg) || strengthMg <= 0) return NaN;
          return doseMg / strengthMg;
        }
        if (s.unit === 'iu') {
          const doseIU = iuToIU(d.value);
          const strengthIU = iuToIU(s.value);
          if (isNaN(doseIU) || isNaN(strengthIU) || strengthIU <= 0) return NaN;
          return doseIU / strengthIU;
        }
        return NaN;
      };

      const unitsPerDose = computeUnitsPerDose();
      if (!isNaN(unitsPerDose) && dosesPerDay && days) {
        const rawQty = unitsPerDose * dosesPerDay * days;
        const quantity = Math.max(1, Math.ceil(rawQty));
        formInstance.setFieldsValue({ quantity });
      }
    } catch (e) {
      // silent
    }
  };

  const massToMg = (value, unit) => {
    const u = normalizeUnit(unit);
    if (isNaN(value)) return NaN;
    if (u === 'mg') return value;
    if (u === 'mcg') return value / 1000;
    if (u === 'g') return value * 1000;
    return NaN;
  };

  const iuToIU = (value) => (isNaN(value) ? NaN : value);

  // Effect to populate form when edit modal opens
  useEffect(() => {
    if (isEditModalVisible && editingMedication) {
      const medicationName = editingMedication.drugName || editingMedication.medicationName;
      setSelectedMedication(medicationName);
      
      const mappedRecord = {
        drugName: medicationName,
        strength: editingMedication.strength,
        route: editingMedication.route,
        dose: editingMedication.dose,
        frequency: editingMedication.frequency,
        duration: editingMedication.duration,
        quantity: editingMedication.amount || editingMedication.quantity,
        refills: editingMedication.refills
      };
      
      console.log('useEffect: Setting form values:', mappedRecord);
      editForm.setFieldsValue(mappedRecord);
    }
  }, [isEditModalVisible, editingMedication, editForm]);

  const defaultPharmacy = useMemo(() => ({
    name: '',
    address: '',
    phone: '',
    fax: ''
  }), []);

  // Fetch patient pharmacy data
  const fetchPatientPharmacyData = useCallback(async () => {
    try {
      const token = authState?.obj?.token || authState?.token || (JSON.parse(localStorage.getItem('userInfo') || '{}')?.token);

      // token exists (kept for future use if needed)
      if (token) {
        // no-op for now; auth handled by redux actions
      }

      const response = await dispatch(getUserProfile());
      const userData = response?.obj || response;

      if (userData && (userData.pharmacyName || userData.pharmacyAddress || userData.pharmacyPhoneNumber || userData.pharmacyFaxNumber)) {
        const pd = {
          name: userData.pharmacyName || '',
          address: userData.pharmacyAddress || '',
          phone: userData.pharmacyPhoneNumber || '',
          fax: userData.pharmacyFaxNumber || ''
        };
        form.setFieldsValue(pd);
      } else {
        // fallback: try saved pharmacyDetails in localStorage, otherwise default
        const stored = localStorage.getItem('pharmacyDetails');
        if (stored) {
          try {
            const parsed = JSON.parse(stored);
            form.setFieldsValue(parsed);
          } catch (e) {
            form.setFieldsValue(defaultPharmacy);
          }
        } else {
          form.setFieldsValue(defaultPharmacy);
        }
      }
    } catch (error) {
      console.error('Error fetching patient pharmacy data:', error);
      form.setFieldsValue(defaultPharmacy);
    } finally {
    }
  }, [dispatch, authState, form, defaultPharmacy]);

  useEffect(() => {
    fetchPatientPharmacyData();
  }, [fetchPatientPharmacyData]);

  // helper to fetch image and convert to data URL (works with remote URLs, falls back on data: URLs)
  const fetchImageDataUrl = async (url) => {
    try {
      if (!url) return null;
      if (String(url).startsWith('data:')) return url;
      const res = await fetch(url);
      if (!res.ok) return null;
      const blob = await res.blob();
      return await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    } catch (err) {
      console.warn('Failed to fetch signature image as data URL:', err);
      return null;
    }
  };

  return (
    <div>
      {patient ? (
        <Header />
      ) : (
        "Select a patient to view their medications and supplements"
      )}

      {/* Modal for selecting a patient */}
      <Modal
        title="No Patient Selected"
        open={isModalVisible}
        footer={[

          <Button key="ok" type="primary" onClick={handleModalClose}>
            Select Patient
          </Button>,
        ]}
        closable={false}
        maskClosable={false}
      >
        <p>
          Please select a patient to view their medications and supplements.
        </p>
      </Modal>

      <div className="p-6 mt-4" style={{ padding: "0 1%" }}>
        <Tabs activeKey={activeTab} onChange={setActiveTab} items={items} />
      </div>

      {/* Modal for adding a new medication */}
      <Modal
        title="Add New Medication"
        open={isAddModalVisible}
        onOk={handleAdd}
        onCancel={() => {
          // Reset form and states when modal is cancelled
          form.resetFields();
          setSelectedMedication('');
          setSelectedRxnormMedication(null);
          setRxnormRoutes([]);
          setRxnormStrengths([]);
          setSelectedStrength('');
          setCustomStrengthAmount('');
          setCustomStrengthUnit('');
          setRxnormSuggestions([]);
          setIsAddFormValid(false);
          setIsAddModalVisible(false);
        }}
        okText="Add"
        okButtonProps={{ disabled: !isAddFormValid }}
      >
        <Form
          form={form}
          layout="vertical"
          onValuesChange={(changed, all) => {
            // If the clinician manually edited quantity, don't auto-recalculate over it
            if ('quantity' in changed) return;
            const { strength, dose, frequency, duration } = all;

            let dosesPerDay = FREQUENCY_TO_DOSES_PER_DAY[frequency] || 1;
            let days = 1;
          
            // Parse duration
            if (typeof duration === 'string') {
              const dayMatch = duration.match(/(\d+)\s*day/);
              const weekMatch = duration.match(/(\d+)\s*week/);
              const monthMatch = duration.match(/(\d+)\s*month/);
              if (dayMatch) days = parseInt(dayMatch[1]);
              else if (weekMatch) days = parseInt(weekMatch[1]) * 7;
              else if (monthMatch) days = parseInt(monthMatch[1]) * 30;
              else if (!isNaN(Number(duration))) days = Number(duration);
            }
          
            // Handle PRN
            if (frequency === 'As needed (PRN)') {
              dosesPerDay = prnMax || 1;
            }
          
            // Weekly logic
            if (frequency === 'Once weekly') {
              days = Math.ceil(days / 7);
            }
          
            // Parse strength and dose with units (supports mg, mcg, g, IU, mL and concentrations)
            const s = parseAmount(strength);
            const d = parseAmount(dose);

            const computeUnitsPerDose = () => {
              if (!s || !d) return NaN;
              // Concentration strength (e.g., 50 mg/mL)
              if (s.kind === 'concentration') {
                // Dose mass vs concentration → volume needed
                if (d.kind === 'mass') {
                  const doseMg = massToMg(d.value, d.unit);
                  const perMlMg = massToMg(s.numValue, s.numUnit);
                  if (isNaN(doseMg) || isNaN(perMlMg) || perMlMg <= 0) return NaN;
                  return doseMg / perMlMg; // mL per dose
                }
                // Dose in volume with same denominator (e.g., mL)
                if (d.kind === 'volume' && normalizeUnit(s.denUnit) === normalizeUnit(d.unit)) {
                  return d.value; // already volume units per dose
                }
                return NaN;
              }
              // Simple unit strength like 100 mg tablet or 250 mcg capsule
              if (s.kind === 'mass') {
                if (d.kind !== 'mass') return NaN;
                const doseMg = massToMg(d.value, d.unit);
                const strengthMg = massToMg(s.value, s.unit);
                if (isNaN(doseMg) || isNaN(strengthMg) || strengthMg <= 0) return NaN;
                return doseMg / strengthMg; // tablets/capsules per dose (can be fractional)
              }
              // Unit-based strengths like IU: treat as same-unit arithmetic
              if (s.unit === 'iu') {
                const doseIU = iuToIU(d.value);
                const strengthIU = iuToIU(s.value);
                if (isNaN(doseIU) || isNaN(strengthIU) || strengthIU <= 0) return NaN;
                return doseIU / strengthIU;
              }
              return NaN;
            };

            let unitsPerDose = computeUnitsPerDose();
            if (!isNaN(unitsPerDose) && dosesPerDay && days) {
              const rawQty = unitsPerDose * dosesPerDay * days;
              const quantity = Math.max(1, Math.ceil(rawQty));
              form.setFieldsValue({ quantity });
            } else {
              form.setFieldsValue({ quantity: 1 });
            }

            // compute validity for required fields
            try {
              const requiredKeys = ['drugName', 'route', 'strength', 'dose', 'frequency', 'duration'];
              const hasAllRequired = requiredKeys.every((key) => {
                const value = all?.[key];
                return value !== undefined && value !== null && String(value).trim() !== '';
              });
              const hasNoErrors = form
                .getFieldsError(requiredKeys)
                .every((f) => (f?.errors || []).length === 0);
              setIsAddFormValid(Boolean(hasAllRequired && hasNoErrors));
            } catch (e) {
              setIsAddFormValid(false);
            }
          }}
        >
                    <Form.Item
            label="Name"
            name="drugName"
            rules={[

              { required: true, message: "Please select medication name" },
            ]}
          >
            <div style={{maxWidth:"900px"}}>
              {!showCustomMedicationInput ? (
                <Select
                  placeholder="Search and select medication"
                  showSearch
                  allowClear
                  showArrow
                  value={selectedMedication || undefined}
                  filterOption={(input, option) => {
                    const label = option?.label;
                    let text;
                    if (typeof label === 'string') {
                      text = label;
                    } else if (typeof option?.value === 'string') {
                      text = option.value;
                    } else if (label && label.props && label.props.children) {
                      const children = Array.isArray(label.props.children) ? label.props.children : [label.props.children];
                      text = children.filter(c => typeof c === 'string')[0] || '';
                    } else {
                      text = '';
                    }
                    return String(text).toLowerCase().includes(String(input).toLowerCase());
                  }}
                  style={{ 
                    width: '100% !important', 
                    height: '40px', 
                    borderRadius: '8px',
                    border: '1px solid #d9d9d9',
                    fontSize: '14px',
                    backgroundColor: '#fff'
                  }}
                  onSearch={(value) => {
                    // Trigger RxNorm search only
                    handleRxnormSearch(value);
                  }}
                  onChange={(value) => {
                    if (value) {
                      setSelectedMedication(value);
                      form.setFieldsValue({ drugName: value });
                      // Use debounced route resolution for direct medication name input
                      handleMedicationNameChange(value);
                    }
                  }}
                  onSelect={(value, option) => {
                    if (value === '__add_new__') {
                      setShowCustomMedicationInput(true);
                      setCustomMedicationName("");
                      setSelectedMedication(null);
                      form.setFieldsValue({ drugName: null });
                    } else if (value) {
                      // This is an RxNorm medication
                      setSelectedMedication(value);
                      form.setFieldsValue({ drugName: value });
                      const rx = rxnormSuggestions.find(s => s.value === value);
                      if (rx) {
                        setSelectedRxnormMedication(rx);
                        if (rx?.value) {
                          getMedicationRoutes(rx.value).then((routes) => setRxnormRoutes(routes || [])).catch(() => setRxnormRoutes([]));
                          getMedicationStrengths(rx.rxcui).then((s) => setRxnormStrengths(s || [])).catch(() => setRxnormStrengths([]));
                        }
                      } else {
                        setSelectedRxnormMedication(null);
                        setRxnormRoutes([]);
                        setRxnormStrengths([]);
                      }
                    }
                  }}
                  options={[
                    // "Not listed" always shown first
                    {
                      label: (
                        <div style={{ color: '#1890ff', fontWeight: '500', padding: '4px 0' }}>
                          <PlusOutlined style={{ marginRight: '8px' }} />
                          Not listed (please specify)
                        </div>
                      ),
                      value: '__add_new__'
                    },
                    // RxNorm suggestions follow
                    ...rxnormSuggestions.map(med => ({
                      label: med.label,
                      value: med.value,
                      onClick: () => handleRxnormMedicationSelect(med)
                    }))
                    // Previously: only showed "Add New" when rxnormSuggestions.length === 0
                  ]}
                />
              ) : (
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <Input
                    placeholder="Enter medication name"
                    value={customMedicationName}
                    onChange={(e) => setCustomMedicationName(e.target.value)}
                    onPressEnter={() => {
                      if (customMedicationName.trim()) {
                        setSelectedMedication(customMedicationName.trim());
                        form.setFieldsValue({ drugName: customMedicationName.trim() });
                        setShowCustomMedicationInput(false);
                        setCustomMedicationName("");
                        // Clear RxNorm data since this is a custom medication
                        setSelectedRxnormMedication(null);
                        setRxnormRoutes([]);
                        setRxnormStrengths([]);
                      }
                    }}
                    style={{ 
                      flex: 1,
                      height: '40px', 
                      borderRadius: '8px',
                      border: '1px solid #d9d9d9',
                      fontSize: '14px',
                      backgroundColor: '#fff'
                    }}
                    autoFocus
                  />
                  <Button
                    type="primary"
                    onClick={() => {
                      if (customMedicationName.trim()) {
                        setSelectedMedication(customMedicationName.trim());
                        form.setFieldsValue({ drugName: customMedicationName.trim() });
                        setShowCustomMedicationInput(false);
                        setCustomMedicationName("");
                        // Clear RxNorm data since this is a custom medication
                        setSelectedRxnormMedication(null);
                        setRxnormRoutes([]);
                        setRxnormStrengths([]);
                      }
                    }}
                    disabled={!customMedicationName.trim()}
                    style={{ height: '40px' }}
                  >
                    Add
                  </Button>
                  <Button
                    onClick={() => {
                      setShowCustomMedicationInput(false);
                      setCustomMedicationName("");
                    }}
                    style={{ height: '40px' }}
                  >
                    Cancel
                  </Button>
                </div>
              )}
             
             {/* Help text for medication search */}
             <div style={{ 
               marginTop: '8px',
               padding: '6px 12px',
               background: '#f0f8ff',
               borderRadius: '6px',
               border: '1px solid #d6e4ff'
             }}>
               <div style={{ 
                 color: '#597ef7', 
                 fontSize: '12px',
                 lineHeight: '1.4'
               }}>
                 <div style={{ marginBottom: '4px' }}>
                   💡 <strong>Live Search:</strong> Search from thousands of medications using our medication database
                 </div>
                 <div>
                   ✅ <strong>Verified:</strong> All suggestions are verified by medical databases
                 </div>
               </div>
             </div>

             {/* Loading indicator for RxNorm search */}
             {isSearchingRxnorm && (
               <div style={{ 
                 marginTop: '8px',
                 padding: '8px 12px',
                 backgroundColor: '#f6ffed',
                 border: '1px solid #b7eb8f',
                 borderRadius: '6px',
                 fontSize: '12px',
                 color: '#52c41a',
                 display: 'flex',
                 alignItems: 'center',
                 gap: '8px'
               }}>
                 <i className="fas fa-spinner fa-spin"></i>
                 Searching medication database...
               </div>
             )}
             
             {/* Show current selected medication */}
             {selectedMedication && (
               <div style={{ 
                 marginTop: '8px',
                 padding: '8px 12px',
                 background: '#f6ffed',
                 borderRadius: '6px',
                 border: '1px solid #b7eb8f'
               }}>
                 <div style={{ 
                   color: '#52c41a', 
                   fontSize: '12px',
                   fontWeight: '500',
                   display: 'flex',
                   alignItems: 'center',
                   gap: '8px'
                 }}>
                   <span>✅ <strong>Selected Medication:</strong> {selectedMedication}</span>
                 </div>
               </div>
             )}
            </div>
          </Form.Item>
          {/* Show Route only after medication is selected */}
          {selectedMedication && (
            <>
              <Form.Item
                label="Route"
                name="route"
                rules={[{ required: true, message: "Please select route" }]}
              >
                <Select
                  placeholder="Select route"
                  style={{
                    width: '100%',
                    height: '40px',
                    borderRadius: '8px',
                    border: '1px solid #d9d9d9',
                    fontSize: '14px',
                    backgroundColor: '#fff'
                  }}
                  onChange={(value) => {
                    if (value === '__other_route__') {
                      setOtherRoute(true);
                      form.setFieldsValue({ route: '' });
                    } else {
                      setOtherRoute(false);
                      setCustomRoute('');
                      form.setFieldsValue({ route: value });
                    }
                    // Trigger validation check
                    setTimeout(checkAddFormValid, 100);
                  }}
                  options={[
                    { label: "Other (specify)", value: "__other_route__" },
                    { label: "Select route", value: "" },
                    ...(selectedRxnormMedication && rxnormRoutes.length > 0
                      ? rxnormRoutes
                      : ALL_ROUTES
                    ).map(route => ({ label: route, value: route }))
                  ]}
                />
              </Form.Item>
              {otherRoute && (
                <Form.Item label="Specify route">
                  <Input
                    placeholder="e.g. Transdermal, Intramuscular"
                    value={customRoute}
                    onChange={e => {
                      setCustomRoute(e.target.value);
                      form.setFieldsValue({ route: e.target.value });
                      setTimeout(checkAddFormValid, 50);
                    }}
                    style={{ width: '100%', height: '40px', borderRadius: '8px' }}
                  />
                </Form.Item>
              )}
            </>
          )}
          {/* Show Strength only after medication is selected */}
          {selectedMedication && (
            <Form.Item
              label="Strength"
              name="strength"
              rules={[{ required: true, message: "Please select strength" }]}
            >
              <Select
                placeholder="Select strength"
                style={{ 
                  width: '100%', 
                  height: '40px', 
                  borderRadius: '8px',
                  border: '1px solid #d9d9d9',
                  fontSize: '14px',
                  backgroundColor: '#fff'
                }}
                onChange={(val) => {
                  setSelectedStrength(val);
                  form.setFieldsValue({ strength: val });
                  if (val !== '__custom__') {
                    setCustomStrengthAmount("");
                    setCustomStrengthUnit("");
                    form.setFieldsValue({ customStrengthUnit: undefined });
                  }
                  // Trigger validation check
                  setTimeout(checkAddFormValid, 100);
                }}
                options={[
                  { label: "Custom strength...", value: "__custom__" },
                  { label: "Select strength", value: "" },
                  ...(selectedRxnormMedication && rxnormStrengths.length > 0
                    ? rxnormStrengths
                    : DEFAULT_STRENGTHS
                  ).map(strength => ({ label: strength, value: strength }))
                ]}
              />
            </Form.Item>
          )}
          {/* Custom strength builder: value + unit selector */}
          {selectedStrength === '__custom__' && (
            <div style={{ display: 'flex', gap: '8px' }}>
              <Form.Item label="Value" style={{ flex: 1, marginBottom: 0 }}>
                <Input
                  type="number"
                  min={0}
                  step="0.01"
                  placeholder="e.g., 37.5"
                  value={customStrengthAmount}
                onChange={(e) => {
                    const amount = e.target.value;
                    setCustomStrengthAmount(amount);
                    const unit = customStrengthUnit || '';
                    const val = amount ? `${amount} ${unit}`.trim() : '';
                    form.setFieldsValue({ strength: val });
                    recalcQuantityFromForm(form);
                  }}
                />
              </Form.Item>
              <Form.Item label="Unit" style={{ width: '180px', marginBottom: 0 }}>
                <select
                  className="form-control"
                  value={otherStrengthUnit ? '__other_unit__' : customStrengthUnit}
                  onChange={(e) => {
                    const unit = e.target.value;
                    if (unit === '__other_unit__') {
                      setOtherStrengthUnit(true);
                      setCustomStrengthUnit('');
                      return;
                    }
                    setOtherStrengthUnit(false);
                    setCustomStrengthUnit(unit);
                    form.setFieldsValue({ customStrengthUnit: unit });
                    const amount = customStrengthAmount || '';
                    const val = amount ? `${amount} ${unit}`.trim() : '';
                    form.setFieldsValue({ strength: val });
                    recalcQuantityFromForm(form);
                  }}
                  style={{ height: '40px', borderRadius: '8px', padding: '8px 11px' }}
                >
                  <option value="__other_unit__">Other (specify)</option>
                  {/* <option value="">Select unit</option> */}
                  <option value="">Select unit</option>
                  <option value="mcg">mcg</option>
                  <option value="mg">mg</option>
                  <option value="g">g</option>
                  <option value="IU">IU</option>
                  <option value="mg/mL">mg/mL</option>
                  <option value="IU/mL">IU/mL</option>
                  <option value="mL">mL</option>
                  <option value="per spray">per spray</option>
              </select>
            </Form.Item>
            </div>
          )}
          {otherStrengthUnit && (
            <Form.Item label="Specify unit">
              <Input
                placeholder="e.g. units, drops, patches"
                value={customStrengthUnitText}
                onChange={e => {
                  setCustomStrengthUnitText(e.target.value);
                  setCustomStrengthUnit(e.target.value);
                  form.setFieldsValue({ customStrengthUnit: e.target.value });
                  const amount = customStrengthAmount || '';
                  const val = amount ? `${amount} ${e.target.value}`.trim() : '';
                  form.setFieldsValue({ strength: val });
                  recalcQuantityFromForm(form);
                }}
                style={{ width: '100%', height: '40px', borderRadius: '8px' }}
              />
            </Form.Item>
          )}

          {/* Dose field with dynamic options based on selected or custom strength */}
          {(((selectedStrength && selectedStrength !== '__custom__') || (selectedStrength === '__custom__' && form.getFieldValue('strength')))) && (
            <Form.Item
              label="Dose"
              name="dose"
              rules={[{ required: true, message: "Please select dose" }]}
            >
              {!otherDose ? (
                <Select
                  placeholder="Select dose"
                  style={{
                    width: '100%',
                    height: '40px',
                    borderRadius: '8px',
                    border: '1px solid #d9d9d9',
                    fontSize: '14px',
                    backgroundColor: '#fff'
                  }}
                  onChange={(value) => {
                    if (value === '__other_dose__') {
                      setOtherDose(true);
                      form.setFieldsValue({ dose: '' });
                    } else {
                      setOtherDose(false);
                      setCustomDose('');
                      form.setFieldsValue({ dose: value });
                    }
                    setTimeout(checkAddFormValid, 100);
                  }}
                  options={[
                    { label: "Other (specify)", value: "__other_dose__" },
                    { label: "Select dose", value: "" },
                    ...getDoseOptions(form.getFieldValue('strength') || selectedStrength, form.getFieldValue('route'))
                  ]}
                />
              ) : (
                <Input
                  placeholder="e.g. 1 tablet, 2 mL, 0.5 mg"
                  value={customDose}
                  onChange={e => {
                    setCustomDose(e.target.value);
                    form.setFieldsValue({ dose: e.target.value });
                    setTimeout(checkAddFormValid, 50);
                  }}
                  style={{ width: '100%', height: '40px', borderRadius: '8px' }}
                  suffix={
                    <span
                      style={{ cursor: 'pointer', color: '#1890ff', fontSize: '12px' }}
                      onClick={() => {
                        setOtherDose(false);
                        setCustomDose('');
                        form.setFieldsValue({ dose: '' });
                        setTimeout(checkAddFormValid, 50);
                      }}
                    >
                      ← back
                    </span>
                  }
                />
              )}
            </Form.Item>
          )}
          {/* Frequency field */}
          <Form.Item
            label="Frequency"
            name="frequency"
            rules={[{ required: true, message: "Please select frequency" }]}
          >
            {!otherFrequency ? (
              <Select
                placeholder="Select frequency"
                style={{
                  width: '100%',
                  height: '40px',
                  borderRadius: '8px',
                  border: '1px solid #d9d9d9',
                  fontSize: '14px',
                  backgroundColor: '#fff'
                }}
                onChange={(value) => {
                  if (value === '__other_frequency__') {
                    setOtherFrequency(true);
                    form.setFieldsValue({ frequency: '' });
                  } else {
                    setOtherFrequency(false);
                    setCustomFrequency('');
                    form.setFieldsValue({ frequency: value });
                  }
                  if (value !== 'As needed (PRN)') setPrnMax(1);
                  setTimeout(checkAddFormValid, 100);
                }}
                options={[
                  { label: "Other (specify)", value: "__other_frequency__" },
                  { label: "Select frequency", value: "" },
                  { label: "Once daily", value: "Once daily" },
                  { label: "Twice daily", value: "Twice daily" },
                  { label: "Three times daily", value: "Three times daily" },
                  { label: "Every 4 hours", value: "Every 4 hours" },
                  { label: "Every 6 hours", value: "Every 6 hours" },
                  { label: "Every 8 hours", value: "Every 8 hours" },
                  { label: "Every 12 hours", value: "Every 12 hours" },
                  { label: "Once weekly", value: "Once weekly" },
                  { label: "Every other day", value: "Every other day" },
                  { label: "As needed (PRN)", value: "As needed (PRN)" },
                  { label: "One-time dose", value: "One-time dose" }
                ]}
              />
            ) : (
              <Input
                placeholder="e.g. Every 3 days, Twice weekly"
                value={customFrequency}
                onChange={e => {
                  setCustomFrequency(e.target.value);
                  form.setFieldsValue({ frequency: e.target.value });
                  setTimeout(checkAddFormValid, 50);
                }}
                style={{ width: '100%', height: '40px', borderRadius: '8px' }}
                suffix={
                  <span
                    style={{ cursor: 'pointer', color: '#1890ff', fontSize: '12px' }}
                    onClick={() => {
                      setOtherFrequency(false);
                      setCustomFrequency('');
                      form.setFieldsValue({ frequency: '' });
                      setTimeout(checkAddFormValid, 50);
                    }}
                  >
                    ← back
                  </span>
                }
              />
            )}
          </Form.Item>
          {/* PRN max per day helper */}
          {form.getFieldValue('frequency') === 'As needed (PRN)' && (
            <Form.Item label="Max allowed per day?">
              <Input
                type="number"
                min={1}
                value={prnMax}
                onChange={e => setPrnMax(Number(e.target.value) || 1)}
                style={{ width: '100%', height: '40px', borderRadius: '8px' }}
              />
            </Form.Item>
          )}

          {/* Duration field */}
          <Form.Item
            label="Duration"
            name="duration"
            rules={[{ required: true, message: "Please select or enter duration" }]}
          >
            {!otherDuration ? (
              <Select
                placeholder="Select or enter duration"
                style={{
                  width: '100%',
                  height: '40px',
                  borderRadius: '8px',
                  border: '1px solid #d9d9d9',
                  fontSize: '14px',
                  backgroundColor: '#fff'
                }}
                onChange={(value) => {
                  if (value === '__other_duration__') {
                    setOtherDuration(true);
                    form.setFieldsValue({ duration: '' });
                  } else {
                    setOtherDuration(false);
                    setCustomDuration('');
                    form.setFieldsValue({ duration: value });
                  }
                  setTimeout(checkAddFormValid, 100);
                }}
                options={[
                  { label: "Other (specify)", value: "__other_duration__" },
                  { label: "Select duration", value: "" },
                  { label: "3 days", value: "3 days" },
                  { label: "5 days", value: "5 days" },
                  { label: "7 days", value: "7 days" },
                  { label: "10 days", value: "10 days" },
                  { label: "14 days", value: "14 days" },
                  { label: "21 days", value: "21 days" },
                  { label: "28 days", value: "28 days" },
                  { label: "1 month", value: "1 month" },
                  { label: "2 months", value: "2 months" },
                  { label: "3 months", value: "3 months" }
                ]}
              />
            ) : (
              <Input
                placeholder="e.g. Until trigger shot, Ongoing"
                value={customDuration}
                onChange={e => {
                  setCustomDuration(e.target.value);
                  form.setFieldsValue({ duration: e.target.value });
                  setTimeout(checkAddFormValid, 50);
                }}
                style={{ width: '100%', height: '40px', borderRadius: '8px' }}
                suffix={
                  <span
                    style={{ cursor: 'pointer', color: '#1890ff', fontSize: '12px' }}
                    onClick={() => {
                      setOtherDuration(false);
                      setCustomDuration('');
                      form.setFieldsValue({ duration: '' });
                      setTimeout(checkAddFormValid, 50);
                    }}
                  >
                    ← back
                  </span>
                }
              />
            )}
          </Form.Item>

          {/* Quantity field (auto-calculated, but editable override) */}
          <Form.Item
            label="Quantity"
            name="quantity"
            rules={[{ required: true, message: "Please enter quantity" }]}
          >
            <Input
              style={{ width: '100%', height: '40px', borderRadius: '8px' }}
              placeholder="Auto-calculated; type to override (e.g. 30, or 'as directed')"
              onChange={(e) => form.setFieldsValue({ quantity: e.target.value })}
            />
          </Form.Item>

          {/* Refills field */}
          <Form.Item
            label="Refills"
            name="refills"
            rules={[{ required: true, message: "Please enter number of refills" }]}
          >
            {/* <select ... /> — replaced with number input for flexibility */}
            <Input
              placeholder="e.g. 0, 3, 12, or 'as directed'"
              style={{ width: '100%', height: '40px', borderRadius: '8px' }}
              onChange={(e) => form.setFieldsValue({ refills: e.target.value })}
            />
          </Form.Item>

          <Form.Item label="Notes" name="notes">
            <Input.TextArea
              rows={4}
              placeholder="Additional instructions or notes for the patient/pharmacy"
              style={{ borderRadius: '8px' }}
            />
          </Form.Item>
        </Form>
      </Modal>

      {/* Modal for editing medication */}
      <Modal
        title="Edit Medication"
        open={isEditModalVisible}
        onOk={handleEditSubmit}
        onCancel={() => {
          setIsEditModalVisible(false);
          setSelectedMedication(null); // Reset selected medication when closing
        }}
        okText="Update"
      >
        <Form
          form={editForm}
          layout="vertical"
          onValuesChange={(changedValues, allValues) => {
            if ('quantity' in changedValues) return;
            const { dose, strength, frequency, duration } = allValues;

            let dosesPerDay = FREQUENCY_TO_DOSES_PER_DAY[frequency] || 1;
            let days = 1;

            // Parse duration
            if (typeof duration === 'string') {
              const dayMatch = duration.match(/(\d+)\s*day/);
              const weekMatch = duration.match(/(\d+)\s*week/);
              const monthMatch = duration.match(/(\d+)\s*month/);
              if (dayMatch) days = parseInt(dayMatch[1]);
              else if (weekMatch) days = parseInt(weekMatch[1]) * 7;
              else if (monthMatch) days = parseInt(monthMatch[1]) * 30;
              else if (!isNaN(Number(duration))) days = Number(duration);
            }

            // Handle PRN
            if (frequency === 'As needed (PRN)') {
              dosesPerDay = prnMax || 1;
            }

            // Weekly logic
            if (frequency === 'Once weekly') {
              days = Math.ceil(days / 7);
            }

            const s = parseAmount(strength);
            const d = parseAmount(dose);

            const computeUnitsPerDose = () => {
              if (!s || !d) return NaN;
              if (s.kind === 'concentration') {
                if (d.kind === 'mass') {
                  const doseMg = massToMg(d.value, d.unit);
                  const perMlMg = massToMg(s.numValue, s.numUnit);
                  if (isNaN(doseMg) || isNaN(perMlMg) || perMlMg <= 0) return NaN;
                  return doseMg / perMlMg;
                }
                if (d.kind === 'volume' && normalizeUnit(s.denUnit) === normalizeUnit(d.unit)) {
                  return d.value;
                }
                return NaN;
              }
              if (s.kind === 'mass') {
                if (d.kind !== 'mass') return NaN;
                const doseMg = massToMg(d.value, d.unit);
                const strengthMg = massToMg(s.value, s.unit);
                if (isNaN(doseMg) || isNaN(strengthMg) || strengthMg <= 0) return NaN;
                return doseMg / strengthMg;
              }
              if (s.unit === 'iu') {
                const doseIU = iuToIU(d.value);
                const strengthIU = iuToIU(s.value);
                if (isNaN(doseIU) || isNaN(strengthIU) || strengthIU <= 0) return NaN;
                return doseIU / strengthIU;
              }
              return NaN;
            };

            const unitsPerDose = computeUnitsPerDose();
            if (!isNaN(unitsPerDose) && dosesPerDay && days) {
              const rawQty = unitsPerDose * dosesPerDay * days;
              const quantity = Math.max(1, Math.ceil(rawQty));
              editForm.setFieldsValue({ quantity });
            } else {
              editForm.setFieldsValue({ quantity: 1 });
            }
          }}
        >
          <Form.Item
            label="Name"
            name="drugName"
            rules={[
              { required: true, message: "Please enter medication name" },
            ]}
          >
            {/* Edit modal: show existing name in an editable Input instead of empty Select */}
            <Input
              style={{
                width: '100%',
                height: '40px',
                borderRadius: '8px',
                fontSize: '14px',
              }}
              onChange={(e) => {
                setSelectedMedication(e.target.value);
                editForm.setFieldsValue({ drugName: e.target.value });
              }}
            />
          </Form.Item>

          <Form.Item
            label="Strength"
            name="strength"
            rules={[
              { required: true, message: "Please select strength" },
            ]}
          >
            <Select
              placeholder="Select strength"
              showSearch
              style={{
                width: '100%',
                height: '40px',
                borderRadius: '8px',
                border: '1px solid #d9d9d9',
                fontSize: '14px',
                backgroundColor: '#fff'
              }}
              onChange={(value) => {
                setSelectedStrength(value);
                if (value === '__custom__') {
                  editForm.setFieldsValue({ strength: '' });
                } else {
                  setCustomStrengthAmount('');
                  setCustomStrengthUnit('');
                  editForm.setFieldsValue({ strength: value });
                }
              }}
              options={[
                { label: "Custom strength...", value: "__custom__" },
                { label: "Select strength", value: "" },
                // Always include the medication's existing strength so it stays selectable
                ...Array.from(
                  new Set(
                    [editForm.getFieldValue('strength'), ...DEFAULT_STRENGTHS].filter(Boolean)
                  )
                ).map((strength) => ({ label: strength, value: strength }))
              ]}
            />
          </Form.Item>
          {/* Custom strength builder (Edit modal): value + unit selector */}
          {selectedStrength === '__custom__' && (
            <div style={{ display: 'flex', gap: '8px' }}>
              <Form.Item label="Value" style={{ flex: 1, marginBottom: 0 }}>
                <Input
                  type="number"
                  min={0}
                  step="0.01"
                  placeholder="e.g., 37.5"
                  value={customStrengthAmount}
                  onChange={(e) => {
                    const amount = e.target.value;
                    setCustomStrengthAmount(amount);
                    const unit = customStrengthUnit || '';
                    const val = amount ? `${amount} ${unit}`.trim() : '';
                    editForm.setFieldsValue({ strength: val });
                    recalcQuantityFromForm(editForm);
                  }}
                />
              </Form.Item>
              <Form.Item label="Unit" style={{ width: '180px', marginBottom: 0 }}>
                <select
                  className="form-control"
                  value={otherStrengthUnit ? '__other_unit__' : customStrengthUnit}
                  onChange={(e) => {
                    const unit = e.target.value;
                    if (unit === '__other_unit__') {
                      setOtherStrengthUnit(true);
                      setCustomStrengthUnit('');
                      return;
                    }
                    setOtherStrengthUnit(false);
                    setCustomStrengthUnit(unit);
                    const amount = customStrengthAmount || '';
                    const val = amount ? `${amount} ${unit}`.trim() : '';
                    editForm.setFieldsValue({ strength: val });
                    recalcQuantityFromForm(editForm);
                  }}
                  style={{ height: '40px', borderRadius: '8px', padding: '8px 11px' }}
                >
                  <option value="__other_unit__">Other (specify)</option>
                  <option value="">Select unit</option>
                  <option value="mcg">mcg</option>
                  <option value="mg">mg</option>
                  <option value="g">g</option>
                  <option value="IU">IU</option>
                  <option value="mg/mL">mg/mL</option>
                  <option value="IU/mL">IU/mL</option>
                  <option value="mL">mL</option>
                  <option value="per spray">per spray</option>
                </select>
              </Form.Item>
            </div>
          )}
          {selectedStrength === '__custom__' && otherStrengthUnit && (
            <Form.Item label="Specify unit">
              <Input
                placeholder="e.g. units, drops, patches"
                value={customStrengthUnitText}
                onChange={(e) => {
                  setCustomStrengthUnitText(e.target.value);
                  setCustomStrengthUnit(e.target.value);
                  const amount = customStrengthAmount || '';
                  const val = amount ? `${amount} ${e.target.value}`.trim() : '';
                  editForm.setFieldsValue({ strength: val });
                  recalcQuantityFromForm(editForm);
                }}
                style={{ width: '100%', height: '40px', borderRadius: '8px' }}
              />
            </Form.Item>
          )}

          {/* Route — Edit modal */}
          <Form.Item
            label="Route"
            name="route"
            rules={[{ required: true, message: "Please select route" }]}
          >
            <Select
              placeholder="Select route"
              style={{
                width: '100%',
                height: '40px',
                borderRadius: '8px',
                border: '1px solid #d9d9d9',
                fontSize: '14px',
                backgroundColor: '#fff'
              }}
              onChange={(value) => {
                if (value === '__other_route__') {
                  setOtherRoute(true);
                  editForm.setFieldsValue({ route: '' });
                } else {
                  setOtherRoute(false);
                  setCustomRoute('');
                  editForm.setFieldsValue({ route: value });
                }
              }}
              options={[
                { label: "Other (specify)", value: "__other_route__" },
                { label: "Select route", value: "" },
                /*
                <Select.Option value="oral">Oral</Select.Option>
                <Select.Option value="topical">Topical</Select.Option>
                <Select.Option value="injection">Injection</Select.Option>
                <Select.Option value="inhalation">Inhalation</Select.Option>
                <Select.Option value="sublingual">Sublingual</Select.Option>
                <Select.Option value="rectal">Rectal</Select.Option>
                <Select.Option value="vaginal">Vaginal</Select.Option>
                <Select.Option value="ophthalmic">Ophthalmic</Select.Option>
                <Select.Option value="otic">Otic</Select.Option>
                <Select.Option value="nasal">Nasal</Select.Option>
                */
                ...ALL_ROUTES.map(route => ({ label: route, value: route }))
              ]}
            />
          </Form.Item>
          {otherRoute && (
            <Form.Item label="Specify route">
              <Input
                placeholder="e.g. Transdermal, Intramuscular"
                value={customRoute}
                onChange={e => {
                  setCustomRoute(e.target.value);
                  editForm.setFieldsValue({ route: e.target.value });
                }}
                style={{ width: '100%', height: '40px', borderRadius: '8px' }}
              />
            </Form.Item>
          )}

          {/* Dose — Edit modal */}
          <Form.Item
            label="Dose"
            name="dose"
            rules={[{ required: true, message: "Please enter dose" }]}
          >
            {!otherDose ? (
              // { /* <Input placeholder="Enter dose (e.g., 1, 2, 0.5)" ... /> — replaced with Select + Other */ }
              <Select
                placeholder="Select dose"
                style={{
                  width: '100%',
                  height: '40px',
                  borderRadius: '8px',
                  border: '1px solid #d9d9d9',
                  fontSize: '14px',
                  backgroundColor: '#fff'
                }}
                onChange={(value) => {
                  if (value === '__other_dose__') {
                    setOtherDose(true);
                    editForm.setFieldsValue({ dose: '' });
                  } else {
                    setOtherDose(false);
                    setCustomDose('');
                    editForm.setFieldsValue({ dose: value });
                  }
                }}
                options={[
                  { label: "Other (specify)", value: "__other_dose__" },
                  { label: "Select dose", value: "" },
                  ...getDoseOptions(editForm.getFieldValue('strength'), editForm.getFieldValue('route'))
                ]}
              />
            ) : (
              <Input
                placeholder="e.g. 1 tablet, 2 mL, 0.5 mg"
                value={customDose}
                onChange={e => {
                  setCustomDose(e.target.value);
                  editForm.setFieldsValue({ dose: e.target.value });
                }}
                style={{ width: '100%', height: '40px', borderRadius: '8px' }}
                suffix={
                  <span
                    style={{ cursor: 'pointer', color: '#1890ff', fontSize: '12px' }}
                    onClick={() => {
                      setOtherDose(false);
                      setCustomDose('');
                      editForm.setFieldsValue({ dose: '' });
                    }}
                  >
                    ← back
                  </span>
                }
              />
            )}
          </Form.Item>

          {/* Frequency — Edit modal */}
          <Form.Item
            label="Frequency"
            name="frequency"
            rules={[{ required: true, message: "Please select frequency" }]}
          >
            <Select
              placeholder="Select frequency"
              style={{
                width: '100%',
                height: '40px',
                borderRadius: '8px',
                border: '1px solid #d9d9d9',
                fontSize: '14px',
                backgroundColor: '#fff'
              }}
              onChange={(value) => {
                if (value === '__other_frequency__') {
                  setOtherFrequency(true);
                  editForm.setFieldsValue({ frequency: '' });
                } else {
                  setOtherFrequency(false);
                  setCustomFrequency('');
                  editForm.setFieldsValue({ frequency: value });
                }
                if (value !== 'As needed (PRN)') setPrnMax(1);
              }}
              options={[
                { label: "Other (specify)", value: "__other_frequency__" },
                { label: "Select frequency", value: "" },
                /*
                <Select.Option value="1">Once daily</Select.Option>
                <Select.Option value="2">Twice daily</Select.Option>
                ...
                */
                { label: "Once daily", value: "Once daily" },
                { label: "Twice daily", value: "Twice daily" },
                { label: "Three times daily", value: "Three times daily" },
                { label: "Every 4 hours", value: "Every 4 hours" },
                { label: "Every 6 hours", value: "Every 6 hours" },
                { label: "Every 8 hours", value: "Every 8 hours" },
                { label: "Every 12 hours", value: "Every 12 hours" },
                { label: "Once weekly", value: "Once weekly" },
                { label: "Every other day", value: "Every other day" },
                { label: "As needed (PRN)", value: "As needed (PRN)" },
                { label: "One-time dose", value: "One-time dose" }
              ]}
            />
          </Form.Item>
          {otherFrequency && (
            <Form.Item label="Specify frequency">
              <Input
                placeholder="e.g. Every 3 days, Twice weekly"
                value={customFrequency}
                onChange={e => {
                  setCustomFrequency(e.target.value);
                  editForm.setFieldsValue({ frequency: e.target.value });
                }}
                style={{ width: '100%', height: '40px', borderRadius: '8px' }}
              />
            </Form.Item>
          )}

          {/* Duration — Edit modal */}
          <Form.Item
            label="Duration"
            name="duration"
            rules={[{ required: true, message: "Please select duration" }]}
          >
            <Select
              placeholder="Select duration"
              style={{
                width: '100%',
                height: '40px',
                borderRadius: '8px',
                border: '1px solid #d9d9d9',
                fontSize: '14px',
                backgroundColor: '#fff'
              }}
              onChange={(value) => {
                if (value === '__other_duration__') {
                  setOtherDuration(true);
                  editForm.setFieldsValue({ duration: '' });
                } else {
                  setOtherDuration(false);
                  setCustomDuration('');
                  editForm.setFieldsValue({ duration: value });
                }
              }}
              options={[
                { label: "Other (specify)", value: "__other_duration__" },
                { label: "Select duration", value: "" },
                /*
                <Select.Option value="1">1 day</Select.Option>
                <Select.Option value="continuous">Continuous</Select.Option>
                */
                { label: "3 days", value: "3 days" },
                { label: "5 days", value: "5 days" },
                { label: "7 days", value: "7 days" },
                { label: "10 days", value: "10 days" },
                { label: "14 days", value: "14 days" },
                { label: "21 days", value: "21 days" },
                { label: "28 days", value: "28 days" },
                { label: "1 month", value: "1 month" },
                { label: "2 months", value: "2 months" },
                { label: "3 months", value: "3 months" },
                { label: "Continuous", value: "Continuous" }
              ]}
            />
          </Form.Item>
          {otherDuration && (
            <Form.Item label="Specify duration">
              <Input
                placeholder="e.g. Until trigger shot, Ongoing"
                value={customDuration}
                onChange={e => {
                  setCustomDuration(e.target.value);
                  editForm.setFieldsValue({ duration: e.target.value });
                }}
                style={{ width: '100%', height: '40px', borderRadius: '8px' }}
              />
            </Form.Item>
          )}

          {/* Quantity field (auto-calculated, but editable override) */}
          <Form.Item
            label="Quantity"
            name="quantity"
            rules={[{ required: true, message: "Please enter quantity" }]}
          >
            <Input
              style={{ width: '100%', height: '40px', borderRadius: '8px' }}
              placeholder="Auto-calculated; type to override (e.g. 30, or 'as directed')"
              onChange={(e) => editForm.setFieldsValue({ quantity: e.target.value })}
            />
          </Form.Item>

          {/* Refills field */}
          <Form.Item
            label="Refills"
            name="refills"
            rules={[{ required: true, message: "Please enter number of refills" }]}
          >
            {/* <select ... /> — replaced with number input for flexibility */}
            <Input
              placeholder="e.g. 0, 3, 12, or 'as directed'"
              style={{ width: '100%', height: '40px', borderRadius: '8px' }}
              onChange={(e) => editForm.setFieldsValue({ refills: e.target.value })}
            />
          </Form.Item>

          <Form.Item label="Notes" name="notes">
            <Input.TextArea
              rows={4}
              placeholder="Additional instructions or notes for the patient/pharmacy"
              style={{ borderRadius: '8px' }}
            />
          </Form.Item>
        </Form>
      </Modal>

      {/* Modal for adding a new supplement */}
      <Modal
        title="Add New Supplement"
        open={isAddSupplementModalVisible}
        onOk={handleAddSupplement}
        onCancel={() => {
          setIsAddSupplementModalVisible(false);
          setOtherSupplementRoute(false);
          setCustomSupplementRoute("");
          setOtherSupplementFrequency(false);
          setCustomSupplementFrequency("");
          setOtherSupplementMetric(false);
          setCustomSupplementMetric("");
          setOtherSupplementAmountExtra(false);
          setCustomSupplementAmountExtra("");
        }}
        okText="Add"
        width={500}
      >
        <Form
          form={supplementForm}
          layout="vertical"
        >
          <div style={{ padding: "20px 0" }}>
            <div style={{ marginBottom: "20px" }}>
              <div style={{ fontWeight: "bold", marginBottom: "8px" }}>
                <span style={{ color: '#ff4d4f' }}>*</span> Supplement Name
              </div>
              <Form.Item name="SupplementName" noStyle rules={[{ required: true, message: 'Please enter supplement name' }]}>
                <Input
                  style={{
                    width: "100%",
                    height: "40px",
                    borderRadius: "8px",
                    border: "1px solid #d9d9d9",
                  }}
                />
              </Form.Item>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <div style={{ fontWeight: "bold", marginBottom: "8px" }}><span style={{ color: '#ff4d4f' }}>*</span> Dose</div>
              <div style={{ display: "flex", gap: "10px" }}>
                <Form.Item name="Dose" noStyle rules={[{ required: true, message: 'Please enter dose' }]}>
                  <Input
                    placeholder="Enter"
                    style={{
                      flex: 1,
                      minWidth: 0,
                      height: "40px",
                      borderRadius: "8px",
                      border: "1px solid #d9d9d9",
                    }}
                  />
                </Form.Item>
                <Form.Item name="Metric" noStyle rules={[{ required: true, message: 'Please select metric' }]}>
                  <Select
                    placeholder="Select"
                    style={{
                      flex: 1,
                      minWidth: 150,
                      height: "40px",
                      borderRadius: "8px",
                    }}
                    onChange={(value) => {
                      if (value === '__other_supplement_metric__') {
                        setOtherSupplementMetric(true);
                        supplementForm.setFieldsValue({ Metric: '' });
                      } else {
                        setOtherSupplementMetric(false);
                        setCustomSupplementMetric('');
                        supplementForm.setFieldsValue({ Metric: value });
                      }
                    }}
                  >
                    <Select.Option value="__other_supplement_metric__">Other (specify)</Select.Option>
                    <Select.Option value="mg">mg</Select.Option>
                    <Select.Option value="g">g</Select.Option>
                    <Select.Option value="ml">ml</Select.Option>
                  </Select>
                </Form.Item>
              </div>
              {otherSupplementMetric && (
                <Input
                  placeholder="e.g. mcg, IU"
                  value={customSupplementMetric}
                  onChange={e => {
                    setCustomSupplementMetric(e.target.value);
                    supplementForm.setFieldsValue({ Metric: e.target.value });
                  }}
                  style={{ width: '100%', height: '40px', borderRadius: '8px', marginTop: '8px' }}
                />
              )}
            </div>

            <div style={{ marginBottom: "20px" }}>
              <div style={{ fontWeight: "bold", marginBottom: "8px" }}>
                <span style={{ color: '#ff4d4f' }}>*</span> Amount
              </div>
              <div style={{ display: "flex", gap: "10px" }}>
                <Form.Item name="Amount" noStyle rules={[{ required: true, message: 'Please enter amount' }]}>
                  <Input
                    placeholder="Enter"
                    style={{
                      flex: 1,
                      height: "40px",
                      borderRadius: "8px",
                      border: "1px solid #d9d9d9",
                    }}
                  />
                </Form.Item>
                <Form.Item name="AmountExtra" noStyle rules={[{ required: true, message: 'Please select amount type' }]}>
                  <Select
                    placeholder="Select"
                    style={{
                      flex: 3,
                      height: "40px",
                      borderRadius: "8px",
                    }}
                    onChange={(value) => {
                      if (value === '__other_supplement_amount_extra__') {
                        setOtherSupplementAmountExtra(true);
                        supplementForm.setFieldsValue({ AmountExtra: '' });
                      } else {
                        setOtherSupplementAmountExtra(false);
                        setCustomSupplementAmountExtra('');
                        supplementForm.setFieldsValue({ AmountExtra: value });
                      }
                    }}
                  >
                    <Select.Option value="__other_supplement_amount_extra__">Other (specify)</Select.Option>
                    <Select.Option value="tablets">tablets</Select.Option>
                    <Select.Option value="capsules">capsules</Select.Option>
                    <Select.Option value="drops">drops</Select.Option>
                  </Select>
                </Form.Item>
              </div>
              {otherSupplementAmountExtra && (
                <Input
                  placeholder="e.g. sprays, patches"
                  value={customSupplementAmountExtra}
                  onChange={e => {
                    setCustomSupplementAmountExtra(e.target.value);
                    supplementForm.setFieldsValue({ AmountExtra: e.target.value });
                  }}
                  style={{ width: '100%', height: '40px', borderRadius: '8px', marginTop: '8px' }}
                />
              )}
            </div>
            <div className="flex flex-row gap-4">
              <div style={{ marginBottom: "20px", flex: 1 }}>
                <div style={{ fontWeight: "bold", marginBottom: "8px" }}>
                  <span style={{ color: '#ff4d4f' }}>*</span> Route
                </div>
                <Form.Item name="Route" noStyle rules={[{ required: true, message: 'Please select route' }]}>
                  <Select
                    placeholder="Select"
                    className="w-full select-supplement"
                    style={{
                      width: "100%",
                      height: "40px",
                      borderRadius: "8px",
                    }}
                    onChange={(value) => {
                      if (value === '__other_supplement_route__') {
                        setOtherSupplementRoute(true);
                        supplementForm.setFieldsValue({ Route: '' });
                      } else {
                        setOtherSupplementRoute(false);
                        setCustomSupplementRoute('');
                        supplementForm.setFieldsValue({ Route: value });
                      }
                    }}
                  >
                    <Select.Option value="__other_supplement_route__">Other (specify)</Select.Option>
                    <Select.Option value="oral">Oral</Select.Option>
                    <Select.Option value="topical">Topical</Select.Option>
                    <Select.Option value="injection">Injection</Select.Option>
                  </Select>
                </Form.Item>
                {otherSupplementRoute && (
                  <Input
                    placeholder="e.g. Sublingual, Rectal"
                    value={customSupplementRoute}
                    onChange={e => {
                      setCustomSupplementRoute(e.target.value);
                      supplementForm.setFieldsValue({ Route: e.target.value });
                    }}
                    style={{ width: '100%', height: '40px', borderRadius: '8px', marginTop: '8px' }}
                  />
                )}
              </div>

              <div style={{ marginBottom: "20px", flex: 1 }}>
                <div style={{ fontWeight: "bold", marginBottom: "8px" }}>
                  <span style={{ color: '#ff4d4f' }}>*</span> Frequency
                </div>
                <Form.Item name="Frequency" noStyle rules={[{ required: true, message: 'Please select frequency' }]}>
                  <Select
                    placeholder="Select"
                    className="w-full select-supplement"
                    style={{
                      width: "100%",
                      height: "40px",
                      borderRadius: "8px",
                    }}
                    onChange={(value) => {
                      if (value === '__other_supplement_frequency__') {
                        setOtherSupplementFrequency(true);
                        supplementForm.setFieldsValue({ Frequency: '' });
                      } else {
                        setOtherSupplementFrequency(false);
                        setCustomSupplementFrequency('');
                        supplementForm.setFieldsValue({ Frequency: value });
                      }
                    }}
                  >
                    <Select.Option value="__other_supplement_frequency__">Other (specify)</Select.Option>
                    <Select.Option value="daily">Daily</Select.Option>
                    <Select.Option value="twice_daily">Twice Daily</Select.Option>
                    <Select.Option value="weekly">Weekly</Select.Option>
                    <Select.Option value="monthly">Monthly</Select.Option>
                  </Select>
                </Form.Item>
                {otherSupplementFrequency && (
                  <Input
                    placeholder="e.g. Every other day"
                    value={customSupplementFrequency}
                    onChange={e => {
                      setCustomSupplementFrequency(e.target.value);
                      supplementForm.setFieldsValue({ Frequency: e.target.value });
                    }}
                    style={{ width: '100%', height: '40px', borderRadius: '8px', marginTop: '8px' }}
                  />
                )}
              </div>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <div style={{ fontWeight: "bold", marginBottom: "8px" }}><span style={{ color: '#ff4d4f' }}>*</span> Notes</div>
              <Form.Item name="Notes" noStyle rules={[{ required: true, message: 'Please enter notes' }]}>
                <Input.TextArea
                  rows={4}
                  style={{
                    width: "100%",
                    borderRadius: "8px",
                    border: "1px solid #d9d9d9",
                  }}
                />
              </Form.Item>
            </div>
          </div>
        </Form>
      </Modal>

      {/* Modal for editing an existing supplement */}
      <Modal
        title="Edit Supplement"
        open={isEditSupplementModalVisible}
        onOk={handleEditSupplementSubmit}
        onCancel={closeEditSupplementModal}
        okText="Save"
        width={500}
      >
        <Form
          form={editSupplementForm}
          layout="vertical"
        >
          <div style={{ padding: "20px 0" }}>
            <div style={{ marginBottom: "20px" }}>
              <div style={{ fontWeight: "bold", marginBottom: "8px" }}>
                <span style={{ color: '#ff4d4f' }}>*</span> Supplement Name
              </div>
              <Form.Item name="SupplementName" noStyle rules={[{ required: true, message: 'Please enter supplement name' }]}>
                <Input
                  style={{
                    width: "100%",
                    height: "40px",
                    borderRadius: "8px",
                    border: "1px solid #d9d9d9",
                  }}
                />
              </Form.Item>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <div style={{ fontWeight: "bold", marginBottom: "8px" }}><span style={{ color: '#ff4d4f' }}>*</span> Dose</div>
              <div style={{ display: "flex", gap: "10px" }}>
                <Form.Item name="Dose" noStyle rules={[{ required: true, message: 'Please enter dose' }]}>
                  <Input
                    placeholder="Enter"
                    style={{
                      flex: 1,
                      minWidth: 0,
                      height: "40px",
                      borderRadius: "8px",
                      border: "1px solid #d9d9d9",
                    }}
                  />
                </Form.Item>
                <Form.Item name="Metric" noStyle rules={[{ required: true, message: 'Please select metric' }]}>
                  <Select
                    placeholder="Select"
                    style={{
                      flex: 1,
                      minWidth: 150,
                      height: "40px",
                      borderRadius: "8px",
                    }}
                    onChange={(value) => {
                      if (value === '__other_supplement_metric__') {
                        setOtherEditSupplementMetric(true);
                        editSupplementForm.setFieldsValue({ Metric: '' });
                      } else {
                        setOtherEditSupplementMetric(false);
                        setCustomEditSupplementMetric('');
                        editSupplementForm.setFieldsValue({ Metric: value });
                      }
                    }}
                  >
                    <Select.Option value="__other_supplement_metric__">Other (specify)</Select.Option>
                    <Select.Option value="mg">mg</Select.Option>
                    <Select.Option value="g">g</Select.Option>
                    <Select.Option value="ml">ml</Select.Option>
                  </Select>
                </Form.Item>
              </div>
              {otherEditSupplementMetric && (
                <Input
                  placeholder="e.g. mcg, IU"
                  value={customEditSupplementMetric}
                  onChange={e => {
                    setCustomEditSupplementMetric(e.target.value);
                    editSupplementForm.setFieldsValue({ Metric: e.target.value });
                  }}
                  style={{ width: '100%', height: '40px', borderRadius: '8px', marginTop: '8px' }}
                />
              )}
            </div>

            <div style={{ marginBottom: "20px" }}>
              <div style={{ fontWeight: "bold", marginBottom: "8px" }}>
                <span style={{ color: '#ff4d4f' }}>*</span> Amount
              </div>
              <div style={{ display: "flex", gap: "10px" }}>
                <Form.Item name="Amount" noStyle rules={[{ required: true, message: 'Please enter amount' }]}>
                  <Input
                    placeholder="Enter"
                    style={{
                      flex: 1,
                      height: "40px",
                      borderRadius: "8px",
                      border: "1px solid #d9d9d9",
                    }}
                  />
                </Form.Item>
                <Form.Item name="AmountExtra" noStyle rules={[{ required: true, message: 'Please select amount type' }]}>
                  <Select
                    placeholder="Select"
                    style={{
                      flex: 3,
                      height: "40px",
                      borderRadius: "8px",
                    }}
                    onChange={(value) => {
                      if (value === '__other_supplement_amount_extra__') {
                        setOtherEditSupplementAmountExtra(true);
                        editSupplementForm.setFieldsValue({ AmountExtra: '' });
                      } else {
                        setOtherEditSupplementAmountExtra(false);
                        setCustomEditSupplementAmountExtra('');
                        editSupplementForm.setFieldsValue({ AmountExtra: value });
                      }
                    }}
                  >
                    <Select.Option value="__other_supplement_amount_extra__">Other (specify)</Select.Option>
                    <Select.Option value="tablets">tablets</Select.Option>
                    <Select.Option value="capsules">capsules</Select.Option>
                    <Select.Option value="drops">drops</Select.Option>
                  </Select>
                </Form.Item>
              </div>
              {otherEditSupplementAmountExtra && (
                <Input
                  placeholder="e.g. sprays, patches"
                  value={customEditSupplementAmountExtra}
                  onChange={e => {
                    setCustomEditSupplementAmountExtra(e.target.value);
                    editSupplementForm.setFieldsValue({ AmountExtra: e.target.value });
                  }}
                  style={{ width: '100%', height: '40px', borderRadius: '8px', marginTop: '8px' }}
                />
              )}
            </div>
            <div className="flex flex-row gap-4">
              <div style={{ marginBottom: "20px", flex: 1 }}>
                <div style={{ fontWeight: "bold", marginBottom: "8px" }}>
                  <span style={{ color: '#ff4d4f' }}>*</span> Route
                </div>
                <Form.Item name="Route" noStyle rules={[{ required: true, message: 'Please select route' }]}>
                  <Select
                    placeholder="Select"
                    className="w-full select-supplement"
                    style={{
                      width: "100%",
                      height: "40px",
                      borderRadius: "8px",
                    }}
                    onChange={(value) => {
                      if (value === '__other_supplement_route__') {
                        setOtherEditSupplementRoute(true);
                        editSupplementForm.setFieldsValue({ Route: '' });
                      } else {
                        setOtherEditSupplementRoute(false);
                        setCustomEditSupplementRoute('');
                        editSupplementForm.setFieldsValue({ Route: value });
                      }
                    }}
                  >
                    <Select.Option value="__other_supplement_route__">Other (specify)</Select.Option>
                    <Select.Option value="oral">Oral</Select.Option>
                    <Select.Option value="topical">Topical</Select.Option>
                    <Select.Option value="injection">Injection</Select.Option>
                  </Select>
                </Form.Item>
                {otherEditSupplementRoute && (
                  <Input
                    placeholder="e.g. Sublingual, Rectal"
                    value={customEditSupplementRoute}
                    onChange={e => {
                      setCustomEditSupplementRoute(e.target.value);
                      editSupplementForm.setFieldsValue({ Route: e.target.value });
                    }}
                    style={{ width: '100%', height: '40px', borderRadius: '8px', marginTop: '8px' }}
                  />
                )}
              </div>

              <div style={{ marginBottom: "20px", flex: 1 }}>
                <div style={{ fontWeight: "bold", marginBottom: "8px" }}>
                  <span style={{ color: '#ff4d4f' }}>*</span> Frequency
                </div>
                <Form.Item name="Frequency" noStyle rules={[{ required: true, message: 'Please select frequency' }]}>
                  <Select
                    placeholder="Select"
                    className="w-full select-supplement"
                    style={{
                      width: "100%",
                      height: "40px",
                      borderRadius: "8px",
                    }}
                    onChange={(value) => {
                      if (value === '__other_supplement_frequency__') {
                        setOtherEditSupplementFrequency(true);
                        editSupplementForm.setFieldsValue({ Frequency: '' });
                      } else {
                        setOtherEditSupplementFrequency(false);
                        setCustomEditSupplementFrequency('');
                        editSupplementForm.setFieldsValue({ Frequency: value });
                      }
                    }}
                  >
                    <Select.Option value="__other_supplement_frequency__">Other (specify)</Select.Option>
                    <Select.Option value="daily">Daily</Select.Option>
                    <Select.Option value="twice_daily">Twice Daily</Select.Option>
                    <Select.Option value="weekly">Weekly</Select.Option>
                    <Select.Option value="monthly">Monthly</Select.Option>
                  </Select>
                </Form.Item>
                {otherEditSupplementFrequency && (
                  <Input
                    placeholder="e.g. Every other day"
                    value={customEditSupplementFrequency}
                    onChange={e => {
                      setCustomEditSupplementFrequency(e.target.value);
                      editSupplementForm.setFieldsValue({ Frequency: e.target.value });
                    }}
                    style={{ width: '100%', height: '40px', borderRadius: '8px', marginTop: '8px' }}
                  />
                )}
              </div>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <div style={{ fontWeight: "bold", marginBottom: "8px" }}><span style={{ color: '#ff4d4f' }}>*</span> Notes</div>
              <Form.Item name="Notes" noStyle rules={[{ required: true, message: 'Please enter notes' }]}>
                <Input.TextArea
                  rows={4}
                  style={{
                    width: "100%",
                    borderRadius: "8px",
                    border: "1px solid #d9d9d9",
                  }}
                />
              </Form.Item>
            </div>
          </div>
        </Form>
      </Modal>
      <Modal
        title="Upload New Prescription"
        open={isUploadModalVisible}
        onCancel={() => {
          setIsUploadModalVisible(false);
          setNewLabResultFile(null);
          setNewLabResultName("");
        }}
        onOk={async () => {
          if (!newLabResultFile || !newLabResultName.trim()) {
            message.error("Please select a file and enter a name.");
            return;
          }

          const reader = new FileReader();
          reader.readAsDataURL(newLabResultFile);
          reader.onload = async () => {
            const base64String = reader.result.split(",")[1];
            const payload = {
              patientRef: patient.userRef,
              bloodWork: [
                {
                  base64: base64String,
                  filename: newLabResultFile.name,
                  fileTitle: newLabResultName.trim(),
                  fileType: 3,
                },
              ],
            };

            try {
              await dispatch(addPatientDocuments(payload)).unwrap();
              await fetchPatientBloodWork();
              message.success("Prescription File uploaded successfully!");
              setIsUploadModalVisible(false);
              setNewLabResultFile(null);
              setNewLabResultName("");
            } catch (error) {
              message.error("Upload failed.");
            }
          };
        }}
        okText="Upload"
      >
        <Input
          placeholder="Enter Prescription name"
          style={{ marginBottom: "15px" }}
          value={newLabResultName}
          onChange={(e) => setNewLabResultName(e.target.value)}
        />
        <Text strong>Upload File</Text>
        <Dragger
          name="file"
          multiple={false}
          showUploadList={false}
          beforeUpload={(file) => {
            const allowedTypes = [
              "application/pdf",
              "image/jpeg",
              "image/jpg",
              "image/png",
            ];
            if (!allowedTypes.includes(file.type)) {
              message.error("Only PDF, JPG, and PNG files are allowed.");
              return Upload.LIST_IGNORE;
            }
            setNewLabResultFile(file);
            return false;
          }}
        >
          <p className="ant-upload-drag-icon">
            <UploadOutlined />
          </p>
          <p className="ant-upload-text">Drag and drop file</p>
          <p className="ant-upload-hint">- OR -</p>
          <Button icon={<UploadOutlined />}>Browse Files</Button>
        </Dragger>
        {newLabResultFile && (
          <div style={{ marginTop: "10px" }}>
            <Text>Selected File: {newLabResultFile.name}</Text>
          </div>
        )}
      </Modal>

      {/* At the bottom of the medication list UI */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        gap: isMobile ? 12 : 24, 
        margin: '32px 0',
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: 'center'
      }}>
       
        <Button
          type="default"
          size={isMobile ? "middle" : "large"}
          style={{ 
            borderRadius: 8, 
            fontWeight: 'bold', 
            border: '2px solid #00ADEF', 
            color: '#00ADEF',
            width: isMobile ? '100%' : 'auto',
            height: isMobile ? '40px' : 'auto'
          }}
          onClick={handleFaxToPharmacy}
        >
          Fax to Pharmacy
        </Button>
        <Button
          type="dashed"
          size={isMobile ? "middle" : "large"}
          style={{ 
            borderRadius: 8, 
            fontWeight: 'bold', 
            border: '2px dashed #1a3c6b', 
            color: '#1a3c6b',
            width: isMobile ? '100%' : 'auto',
            height: isMobile ? '40px' : 'auto'
          }}
          onClick={() => setPreviewVisible(true)}
        >
          Prescription Preview
        </Button>
      </div>
      <Modal
        open={previewVisible}
        onCancel={() => setPreviewVisible(false)}
        footer={[
          <Button key="download" type="primary" icon={<DownloadOutlined />} onClick={exportToPDF} style={{ background: '#52c41a', borderColor: '#52c41a' }}>
            Download PDF
          </Button>
        ]}
        width={700}
        style={{ top: 24 }}
        bodyStyle={{ padding: 0, background: '#f8f8f8' }}
        destroyOnClose
      >
        <PrescriptionPreview patientInfo={patient} />
      </Modal>

      {/* Pharmacy Confirmation Modal */}
      <PharmacyConfirmationModal
        visible={pharmacyModalVisible}
        onCancel={handlePharmacyCancel}
        onConfirm={handlePharmacyConfirm}
        fileRef={selectedFileForFax?.fileRef}
        fileName={selectedFileForFax?.fileName}
        loading={faxLoading}
      />

    </div>
  );
};

export default MedicationTable;